import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import * as Cookies from 'js-cookie';
import { TNKAuthLoanFormService } from './auth-loan-form.service';
import { Router, NavigationEnd } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { PlatformService } from '../../services/platform.services';
import { Subscription } from 'rxjs';

import {
  LOAN_PURPOSE_ENTREPRENEUR,
  BUSINESS_TYPE_ENTREPRENEUR,
  BUSINESS_AGE_ENTREPRENEUR,
  BUSINESS_PROMOTION_ENTREPRENEUR,
  ONLINE_CHANNEL_ENTREPRENEUR,
  BUSINESS_PLACE_ENTREPRENEUR,
  NUMBER_OF_EMPLOYEES_ENTREPRENEUR,
  HELPED_BY_FAMILY_MEMBERS,
  BusinessTypeEntrepreneur,
  BusinessAgeEntrepreneur,
  BusinessPromotionEntrepreneur,
  OnlineChannelEntrepreneur,
  BusinessPlaceEntrepreneur,
  NumberOfEmployeesEntrepreneur,
  HelpedByFamilyMembers,
  LoanPurposeEntrepreneur,
} from '../../shared/constants/loan-form-entrepreneur.constant';

import { numericalInputOnly } from '../../utils/input-handler/numerical-input-only';
import { numberDelimiter } from '../../utils/input-handler/number-delimiter';

declare const window: any;
declare const $zopim: any;
export class TNKAuthLoanFormComponent implements OnInit {
public loanForm: FormGroup;
public formData: any;
public loanFormData: any;
public hideButton: boolean = true;
public additionalParameter: any;
public os: any;
public device: any;
public browserType: any;
public platform: any;
private loanInfo: any;
private isCookie: any = false;
private subscription1: Subscription;
private subscription2: Subscription;
public LOAN_PURPOSE_ENTREPRENEUR: LoanPurposeEntrepreneur = LOAN_PURPOSE_ENTREPRENEUR;
public BUSINESS_TYPE_ENTREPRENEUR: BusinessTypeEntrepreneur = BUSINESS_TYPE_ENTREPRENEUR;
public BUSINESS_AGE_ENTREPRENEUR: BusinessAgeEntrepreneur = BUSINESS_AGE_ENTREPRENEUR;
public BUSINESS_PROMOTION_ENTREPRENEUR: BusinessPromotionEntrepreneur = BUSINESS_PROMOTION_ENTREPRENEUR;
public ONLINE_CHANNEL_ENTREPRENEUR: OnlineChannelEntrepreneur = ONLINE_CHANNEL_ENTREPRENEUR;
public BUSINESS_PLACE_ENTREPRENEUR: BusinessPlaceEntrepreneur = BUSINESS_PLACE_ENTREPRENEUR;
public NUMBER_OF_EMPLOYEES_ENTREPRENEUR: NumberOfEmployeesEntrepreneur = NUMBER_OF_EMPLOYEES_ENTREPRENEUR;
public HELPED_BY_FAMILY_MEMBERS: HelpedByFamilyMembers = HELPED_BY_FAMILY_MEMBERS;
public numericalInputOnly: any = numericalInputOnly;
public numberDelimiter: any = numberDelimiter;
public isFraudAttemptAlert: boolean;
/**
 * @param {?} service
 * @param {?} router
 * @param {?} platformService
 */
constructor(
public service: TNKAuthLoanFormService,
private router: Router,
public platformService: PlatformService,
  ) {}
public accessToken: string;
public cookieService: string;
public successCallbackURI: string;
public errorServerCallbackURI: string;
public stepURI: any[];
public activeStep: number;
public actionButton: boolean;
public busyServerCallbackURI: string;
public isDebug: boolean;
public showForm: boolean = false;
/**
 * @return {?}
 */
onDestroy() {
    this.subscription1.unsubscribe();
    this.subscription2.unsubscribe();
  }
/**
 * @return {?}
 */
ngOnInit() {
    /**
     ** @description get list banks from API
     ** @class LoanFormService -> getBank()
     ** @method getBank()
     ** @return bank <array>
     */
    this.service.getBank();
    /**
     ** @description get list initial provinces from API
     ** @class LoanFormService -> getRegions(data, type, objType?)
     ** @method getRegions()
     ** @return list provinces loanFormData.provinces <array>
     */
    this.service.getRegions({}, 'province');

    /**
     ** @description get additional parameter about device information
     ** @return void
     */
    if (this.platformService.isBrowser) {
      const /** @type {?} */ deviceInformation = navigator.userAgent.split(')')[0].split('(')[1];

      this.device = deviceInformation;
      this.os = deviceInformation;
      this.platform = navigator.platform;
      this.browserType = this.getBrowserInformation();

      const /** @type {?} */ additionalParam = {
        device: this.device,
        os: this.os,
        browser: this.browserType,
        platform: this.platform,
      };

      this.additionalParameter = Object.assign({}, additionalParam);
    }

    this.subscription1 = this.service.data.subscribe(data => {
      this.loanFormData = data;

      this.isFraudAttemptAlert = data.isFraudAttemptAlert;

      if (data.editReviewForm) {
        this.hideButton = false;
      } else {
        this.hideButton = true;
      }
    });

    const /** @type {?} */ sliderData = Cookies.getJSON('TNK-SL-SLRDATA')
      ? Cookies.getJSON('TNK-SL-SLRDATA')
      : null;
    const /** @type {?} */ loanData = Cookies.getJSON('TNK-SL-LNDATA')
      ? Cookies.getJSON('TNK-SL-LNDATA')
      : null;

    if (sliderData && !loanData) {
      this.service.getProfileData(this.accessToken).subscribe(
        (data: any) => {
          this.loanInfo = data.result.newLoanInfo;
          this.isCookie = false;

          this.service.getInitRegions(data.result.newLoanInfo, '');
          this.service.getInitRegions(data.result.newLoanInfo, 'Contact');

          /**
           ** @description build reactive form
           ** @prop Cookies (local cookies / server cookies)
           ** @return void
           */
          this.service.setStore({
            additionalParameter: this.additionalParameter,
            successCallbackURI: this.successCallbackURI,
            errorServerCallbackURI: this.errorServerCallbackURI,
            stepURI: this.stepURI ? this.stepURI : [],
            step: this.activeStep ? this.activeStep : this.loanFormData.step,
            showActionButton: this.actionButton,
            busyServerCallbackURI: this.busyServerCallbackURI,
            accessToken: this.accessToken,
            debug: this.isDebug,
          });
        },
        (error: HttpErrorResponse) => {},
      );
    } else if (loanData) {
      this.loanInfo = loanData;
      this.isCookie = true;
      this.service.getInitRegions(loanData, '', this.isCookie);
      this.service.getInitRegions(loanData, 'Contact', this.isCookie);

      /**
       ** @description build reactive form
       ** @prop Cookies (local cookies / server cookies)
       ** @return void
       */
      this.service.setStore({
        additionalParameter: this.additionalParameter,
        successCallbackURI: this.successCallbackURI,
        errorServerCallbackURI: this.errorServerCallbackURI,
        stepURI: this.stepURI ? this.stepURI : [],
        step: this.activeStep ? this.activeStep : this.loanFormData.step,
        showActionButton: this.actionButton,
        busyServerCallbackURI: this.busyServerCallbackURI,
        accessToken: this.accessToken,
        debug: this.isDebug,
      });
    } else {
      this.router.navigateByUrl('/');
    }
    this.subscription2 = this.service.obsInitRegions.subscribe(data => {
      if (
        (data.isRegionsContactFetched && data.isRegionsDomicileFetched) ||
        data.isError
      ) {
        this.service.buildForm(this.loanInfo, this.isCookie);
        this.showForm = true;
      }
    });

    this.router.events.subscribe(evt => {
      if (evt instanceof NavigationEnd) {
        window.scrollTo(0, 0);
      }
    });
  }
/**
 * @return {?}
 */
public open() {
    this.isFraudAttemptAlert = true;
  }
/**
 * @return {?}
 */
public closeFraudAttemptAlert(): void {
    Cookies.set('showLiveChat', true);

    this.toggleZendesk();

    // To enable toggle zendesk livechat again
    Cookies.remove('showLiveChat');
  }
/**
 * @return {?}
 */
private toggleZendesk(): void {
    if (!window.$zopim) return;

    const /** @type {?} */ showLiveChat = Cookies.get('showLiveChat');
    // Call the zopim/zendesk function to show button chat on dashboard
    $zopim(function() {
      // change color of zendesk livechat
      $zopim.livechat.window.setColor('#FDA951');
      // Check live chat is full screen or just button chat
      showLiveChat
        ? $zopim.livechat.window.show() // Show full live chat
        : $zopim.livechat.button.show(); // Show button live Chat
      // Change the default position offset chat button to Bottom Right (br)
      $zopim.livechat.button.setPositionMobile('br');
      // And then change the vertical offset because it will overlap the navigation
      $zopim.livechat.button.setOffsetVerticalMobile(70);
    });
  }
/**
 * @param {?} name
 * @return {?}
 */
public checkInputValid(name) {
    return this.loanFormData.form.controls[name].valid &&
      !this.loanFormData.form.controls[name].dirty
      ? true
      : null;
  }
/**
 * @param {?} type
 * @param {?} value
 * @return {?}
 */
public handleDelimiter(type: string, value: KeyboardEvent): void {
    this.service.showDelimiter(type, value);
  }
/**
 * @return {?}
 */
getBrowserInformation() {
    const /** @type {?} */ browserInformation = navigator.userAgent;

    let /** @type {?} */ browserType;
    if (browserInformation.includes('Chrome')) {
      browserType = 'Chrome';
    } else if (browserInformation.includes('Firefox')) {
      browserType = 'Firefox';
    } else if (browserInformation.includes('Safari')) {
      browserType = 'Safari';
    } else if (browserInformation.includes('Opera')) {
      browserType = 'Opera';
    } else if (browserInformation.includes('MSIE')) {
      browserType = 'Microsoft Internet Explorer';
    } else if (browserInformation.includes('Mobile')) {
      browserType = 'Mobile Browser';
    } else {
      browserType = 'Unknown Browser';
    }

    return browserType;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'auth-loan-form',
  template: `
    <ng-container *ngIf="!showForm">
      <h3 class="alert title alert-success">
        Mohon menunggu, sedang mengambil data pinjaman anda...
      </h3>
    </ng-container>

    <div class="loanform__wrapper" *ngIf="!loanFormData.submitBusy && showForm">
      <form [formGroup]="loanFormData.form">
        <ng-container *ngIf="loanFormData.step == 1">
          <div class="loanform__card has--subtitle">
            <h4>Data Pribadi</h4>
            <br />
            <div
              class="form-group"
              [ngClass]="{
                'has-error': loanFormData.errors.mobilePhoneNumber,
                'has-success': loanFormData.form.controls.mobilePhoneNumber.valid
              }"
            >
              <label class="help-block">Nomor Handphone</label>

              <div class="input-group">
                <span class="input-group-addon">+62</span>
                <input
                  type="tel"
                  class="form-control"
                  name="mobilePhoneNumber"
                  formControlName="mobilePhoneNumber"
                  id="inp_noHandphone"
                  [attr.disabled]="checkInputValid('mobilePhoneNumber')"
                  (keypress)="numericalInputOnly($event)"
                />
              </div>

              <p class="help-block">{{ loanFormData.errors.mobilePhoneNumber }}</p>
            </div>

            <div
              class="form-group"
              [ngClass]="{
                'has-error': loanFormData.errors.emailAddress,
                'has-success': loanFormData.form.controls.emailAddress.valid
              }"
            >
              <label class="help-block">Email</label>

              <input
                type="text"
                class="form-control"
                name="emailAddress"
                formControlName="emailAddress"
                id="inp_email"
                [attr.disabled]="checkInputValid('emailAddress')"
              />

              <p class="help-block">{{ loanFormData.errors.emailAddress }}</p>
            </div>

            <div
              class="form-group"
              [ngClass]="{
                'has-error': loanFormData.errors.emailIsOwn,
                'has-success': loanFormData.form.controls.emailIsOwn.valid
              }"
            >
              <label class="help-block">Kepemilikan Email</label>

              <select
                class="form-control"
                name="emailIsOwn"
                formControlName="emailIsOwn"
                id="inp_emailIsOwn"
                [attr.disabled]="checkInputValid('emailIsOwn')"
              >
                <option value="0">Pilih salah satu</option>
                <option value="Personal">Email Pribadi</option>
                <option value="Corporate">Email Kantor</option>
                <option value="Other">Lainnya</option>
              </select>

              <p class="help-block">{{ loanFormData.errors.emailIsOwn }}</p>
            </div>

            <div
              class="form-group"
              [ngClass]="{
                'has-error': loanFormData.errors.bankName,
                'has-success': loanFormData.form.controls.bankName.valid
              }"
            >
              <label class="help-block">Nama Bank</label>
              <input
                class="form-control"
                name="bankName"
                formControlName="bankName"
                id="inp_namaBank"
                list="inp_namaBankList"
                [attr.disabled]="checkInputValid('bankName')"
                placeholder="Ketik nama bank anda"
              />
              <datalist id="inp_namaBankList">
                <option
                  *ngFor="let bank of loanFormData.banks"
                  value="{{ bank.name }}"
                ></option>
              </datalist>

              <p class="help-block">{{ loanFormData.errors.bankName }}</p>
            </div>

            <div
              class="form-group"
              [ngClass]="{
                'has-error': loanFormData.errors.bankAccount,
                'has-success': loanFormData.form.controls.bankAccount.valid
              }"
            >
              <label class="help-block">Nomor Rekening</label>

              <input
                type="text"
                class="form-control"
                name="bankAccount"
                formControlName="bankAccount"
                placeholder="Uang pinjaman akan dikirim ke nomor ini"
                id="inp_noRekening"
                [attr.disabled]="checkInputValid('bankAccount')"
                (keypress)="numericalInputOnly($event)"
              />

              <p class="help-block">{{ loanFormData.errors.bankAccount }}</p>
            </div>

            <div
              class="form-group"
              [ngClass]="{
                'has-error': loanFormData.errors.mothersName,
                'has-success': loanFormData.form.controls.mothersName.valid
              }"
            >
              <label class="help-block">Nama Ibu Kandung</label>

              <input
                type="text"
                class="form-control"
                name="mothersName"
                formControlName="mothersName"
                id="inp_namaIbu"
                [attr.disabled]="checkInputValid('mothersName')"
              />

              <p class="help-block">{{ loanFormData.errors.mothersName }}</p>
            </div>

            <!-- <p style="margin-top: 10px" *ngIf="!loanFormData.loadingKTP && referralForm">
    					<span class="icon glyphicon glyphicon-refresh"></span> Mohon menunggu, sedang mengecek KTP Anda...</p> -->
          </div>

          <!-- <div class="loanform__card" *ngIf="!referralForm">
    				<h4 class="border__title">Area Layanan</h4>
				
    				<p>Saat ini Tunaiku dapat melayani Anda yang tinggal atau bekerja di area:</p>

    				<p>
    					<b><span class="icon fa fa-map-marker"></span> JABODETABEK</b><br>
    					Jakarta, Bogor, Depok, Tangerang, Tangerang Selatan, Bekasi
    				</p>

    				<p>
    					<b><span class="icon fa fa-map-marker"></span> SIDOARJO</b>
    				</p>

    				<p>
    					<b><span class="icon fa fa-map-marker"></span> SURABAYA</b>
    				</p>

    				<p>
    					<b><span class="icon fa fa-map-marker"></span> GRESIK</b>
    				</p>

    				<hr class="separator">

    				<p>Apakah Anda tinggal atau bekerja di area layanan kami?</p>

    				<section>
    					<button id="inp_yaAreaLayanan" class="tnk__button button--blue button--hole button--float-left button--margin-sm" (click)="service.setServiceArea('yes')" [ngClass]="{'button--active': loanFormData.serviceAreaIncluded == 'yes' }" [disabled]="!loanFormData.loadingKTP" style="margin-left: 0"><span class="icon fa" [ngClass]="{'fa-circle-thin': loanFormData.serviceAreaIncluded != 'yes', 'fa-check-circle': loanFormData.serviceAreaIncluded == 'yes'}"></span> Ya</button>

    		            <button id="inp_bukanAreaLayanan" class="tnk__button button--blue button--hole button--float-left button--margin-sm" (click)="service.setServiceArea('no')" [ngClass]="{'button--active': loanFormData.serviceAreaIncluded == 'no'}" [disabled]="!loanFormData.loadingKTP"><span class="icon fa" [ngClass]="{'fa-circle-thin': loanFormData.serviceAreaIncluded != 'no', 'fa-check-circle': loanFormData.serviceAreaIncluded == 'no'}"></span> Tidak</button>

    		            <span class="clearfix"></span>

    		            <p style="margin-top: 10px" [hidden]="loanFormData.loadingKTP"><span class="icon glyphicon glyphicon-refresh"></span> Mohon menunggu, sedang mengecek KTP Anda...</p>
    		        </section>

    		        <div class="alert alert-danger" role="alert" *ngIf="loanFormData.serviceAreaIncluded == 'no' && loanFormData.loadingKTP">
    					<h4 class="alert-heading">Area Layanan</h4>
    					<hr>
    					<p>Mohon maaf, saat ini Tunaiku belum bisa melayani di daerah Anda. Untuk pertimbangan perluasan wilayah, sebutkan wilayah dan berikan bintang 5 di Google Review kami.</p>

    					<button id="inp_formGoogleReview" class="tnk__button button--hole button--red button--margin-md button--sm" onclick="javascript:window.open('https://www.google.co.id/search?ei=OHxUWrmUPIjrvgTSl6roBA&q=kredit%20tanpa%20agunan&oq=kredit+tanpa&gs_l=psy-ab.3.1.0i67k1j0i131k1j0i67k1j0l7.7177.8899.0.9792.12.8.0.4.4.0.161.760.0j6.6.0....0...1c.1.64.psy-ab..2.10.788....0.8fruiqRnp6Y&npsic=0&rflfq=1&rlha=0&rllag=-6181926,106809271,2087&tbm=lcl&rldimm=15109014892766128888&ved=0ahUKEwj_6YmpusrYAhUmSY8KHQ_uD7IQvS4IcDAB&rldoc=1&tbs=lrf:!2m1!1e2!2m1!1e3!3sIAE,lf:1,lf_ui:2#rlfi=hd:;si:15109014892766128888;mv:!1m3!1d255097.4225906899!2d106.8321983!3d-6.362325800000001!2m3!1f0!2f0!3f0!3m2!1i270!2i386!4f13.1;tbs:lrf:!2m1!1e2!2m1!1e3!3sIAE,lf:1,lf_ui:2', '_blank')">Voting di Google Review</button>
    				</div>
    			</div> -->
        </ng-container>

        <ng-container *ngIf="loanFormData.step == 2">
          <div class="loanform__card has--subtitle">
            <h4>Data KTP</h4>
            <br />
            <div class="form-group">
              <label class="help-block">Nomor KTP (NIK)</label>
              <input
                type="text"
                class="form-control"
                name="pin_step2"
                [attr.value]="loanFormData.form.controls['pin'].value"
                [attr.disabled]="loanFormData.form.controls.pin.valid"
              />
            </div>

            <div
              class="form-group"
              [ngClass]="{
                'has-error': loanFormData.errors.ktpName,
                'has-success': loanFormData.form.controls.ktpName.valid
              }"
            >
              <label class="help-block">Nama Lengkap (sesuai KTP)</label>

              <input
                type="text"
                class="form-control"
                name="ktpName"
                formControlName="ktpName"
                id="inp_namaKTP"
                (blur)="service.onNameChanged($event.target.value)"
                [attr.disabled]="checkInputValid('ktpName')"
              />

              <p class="help-block">{{ loanFormData.errors.ktpName }}</p>
            </div>

            <span class="clearfix"></span>

            <div
              class="form-group"
              [class.has-error]="loanFormData.errors.birthProvinceId"
              [class.has-success]="loanFormData.form.controls.birthProvinceId.valid"
            >
              <label class="help-block">Tempat Lahir</label>
              <p>Provinsi</p>
              <select
                class="form-control"
                name="birthProvinceId"
                formControlName="birthProvinceId"
                id="inp_tempatLahirProvinsi"
                (change)="service.setBirthPlace($event, 'province')"
                [attr.disabled]="checkInputValid('birthProvinceId')"
              >
                <option value="0">Pilih Salah Satu</option>
                <option
                  *ngFor="let province of loanFormData.provinces"
                  [value]="province.province_id"
                >
                  {{ province.province }}
                </option>
              </select>
            </div>

            <div
              class="form-group"
              [class.has-error]="loanFormData.errors.birthCityId"
              [class.has-success]="loanFormData.form.controls.birthCityId.valid"
            >
              <label class="help-block">Tempat Lahir</label>
              <p>Kota</p>
              <select
                class="form-control"
                name="birthCityid"
                formControlName="birthCityId"
                id="inp_tempatLahirKota"
                (change)="service.setBirthPlace($event, 'city')"
                [attr.disabled]="checkInputValid('birthCityId')"
              >
                <option value="0">Pilih Salah Satu</option>
                <option
                  *ngFor="let city of loanFormData.birthCities"
                  [value]="city.city_id"
                >
                  {{ city.city }}
                </option>
              </select>
            </div>

            <div
              class="form-group"
              [ngClass]="{
                'has-error': loanFormData.errors.dateOfBirth,
                'has-success': loanFormData.form.controls.dateOfBirth.valid
              }"
            >
              <label class="help-block">Tanggal Lahir</label>
              <p>
                Minimal umur 21 tahun akan kami cek kesesuaian dengan KTP Anda saat
                Tanda Tangan Kontrak
              </p>

              <date-dropdown
                #dob
                [dob]="loanFormData.form.value.dateOfBirth"
                [bindForm]="loanFormData.form"
                [bindControlName]="'dateOfBirth'"
                (dateModel)="service.setBirthDate($event)"
                [disabledInput]="loanFormData.form.controls.dateOfBirth.valid"
              ></date-dropdown>

              <p class="help-block">{{ loanFormData.errors.dateOfBirth }}</p>
            </div>

            <div
              class="form-group"
              [ngClass]="{
                'has-error': loanFormData.errors.gender,
                'has-success': loanFormData.form.controls.gender.valid
              }"
            >
              <label class="help-block">Jenis Kelamin</label>

              <button
                id="inp_laki"
                class="tnk__button button--hole button--blue button--margin-sm"
                [ngClass]="{
                  'button--active': loanFormData.form.value['gender'] == 'Male'
                }"
                (click)="loanFormData.form.patchValue({ gender: 'Male' })"
                [attr.disabled]="checkInputValid('gender')"
              >
                <span
                  class="icon fa"
                  [ngClass]="{
                    'fa-circle-thin': loanFormData.form.value.gender != 'Male',
                    'fa-check-circle': loanFormData.form.value.gender == 'Male'
                  }"
                ></span>
                Laki-Laki
              </button>

              <button
                id="inp_perempuan"
                class="tnk__button button--hole button--blue button--margin-sm"
                [ngClass]="{
                  'button--active': loanFormData.form.value['gender'] == 'Female'
                }"
                (click)="loanFormData.form.patchValue({ gender: 'Female' })"
                [attr.disabled]="checkInputValid('gender')"
              >
                <span
                  class="icon fa"
                  [ngClass]="{
                    'fa-circle-thin': loanFormData.form.value.gender != 'Female',
                    'fa-check-circle': loanFormData.form.value.gender == 'Female'
                  }"
                ></span>
                Perempuan
              </button>

              <p class="help-block">{{ loanFormData.errors.gender }}</p>
            </div>

            <div
              class="form-group"
              [hidden]="!loanFormData.PINDataConfirmationBlock"
            >
              <hr />

              <label class="help-block">
                Yakin data pribadi Anda berbeda dengan data di KTP?
              </label>

              <p>
                Sistem kami telah secara otomatis mengisi data pribadi Anda dari
                nomor KTP Anda. Jika Anda mengubah data tersebut, maka data ini akan
                berbeda dengan yang tertulis di KTP Anda.
              </p>

              <div class="col-xs-6 col-sm-6" style="padding-left: 0">
                <button
                  class="tnk__button button--hole button--blue button--block"
                  (click)="service.confirmPINDataChanges(true)"
                >
                  Simpan Perubahan
                </button>
              </div>

              <div class="col-xs-6 col-sm-6" style="padding-right: 0">
                <button
                  class="tnk__button button--hole button--blue button--block"
                  (click)="service.confirmPINDataChanges(false)"
                >
                  Batalkan Perubahan
                </button>
              </div>
            </div>

            <div
              class="form-group"
              [ngClass]="{
                'has-error': loanFormData.errors.religion,
                'has-success': loanFormData.form.controls.religion.valid
              }"
            >
              <label class="help-block">Agama</label>

              <select
                class="form-control"
                name="religion"
                formControlName="religion"
                id="inp_agama"
                [attr.disabled]="checkInputValid('religion')"
              >
                <option value="0">Pilih Salah Satu</option>
                <option value="Muslim">Islam</option>
                <option value="Christian">Kristen</option>
                <option value="Catholic">Katolik</option>
                <option value="Hindu">Hindu</option>
                <option value="Buddha">Budha</option>
                <option value="Other">Lainnya</option>
              </select>

              <p class="help-block">{{ loanFormData.errors.religion }}</p>
            </div>

            <div
              class="form-group"
              [ngClass]="{
                'has-error': loanFormData.errors.citizenship,
                'has-success': loanFormData.form.controls.citizenship.valid
              }"
            >
              <label class="help-block">Kewarganegaraan</label>

              <select
                class="form-control"
                name="citizenship"
                formControlName="citizenship"
                id="inp_kewarganegaraan"
                [attr.disabled]="checkInputValid('citizenship')"
              >
                <option value="0">Pilih Salah Satu</option>
                <option value="Indonesian">WNI</option>
                <option value="NonIndonesian">WNA</option>
                <option value="PermanentResidence">Permanent Residence</option>
              </select>

              <p class="help-block">{{ loanFormData.errors.citizenship }}</p>
            </div>
          </div>

          <div class="loanform__card has--subtitle">
            <h4>Alamat KTP</h4>
            <br />
            <div
              class="form-group"
              [ngClass]="{
                'has-error': loanFormData.errors.domicileAddress_street,
                'has-success':
                  loanFormData.form.controls.domicileAddress_street.valid
              }"
            >
              <label class="help-block">Alamat KTP</label>

              <input
                type="text"
                class="form-control"
                name="domicileAddress_street"
                formControlName="domicileAddress_street"
                id="inp_alamatKTP"
                [attr.disabled]="checkInputValid('domicileAddress_street')"
              />

              <p class="help-block">
                {{ loanFormData.errors.domicileAddress_street }}
              </p>
            </div>

            <div
              class="form-group"
              [ngClass]="{
                'has-error': loanFormData.errors.domicileAddress_buildingType,
                'has-success':
                  loanFormData.form.controls.domicileAddress_buildingType.valid
              }"
            >
              <label class="help-block">Jenis Tempat Tinggal KTP</label>
              <select
                class="form-control"
                name="domicileAddress_buildingType"
                formControlName="domicileAddress_buildingType"
                id="inp_jenisTinggalKTP"
                [attr.disabled]="checkInputValid('domicileAddress_buildingType')"
              >
                <option value="0">Pilih Salah Satu</option>
                <option value="Rumah">Rumah</option>
                <option value="Apartemen">Apartemen</option>
                <option value="Kantor">Kantor</option>
              </select>
              <p class="help-block">
                {{ loanFormData.errors.domicileAddress_buildingType }}
              </p>
            </div>

            <div class="row" style="margin: 0">
              <div class="col-xs-6 col-sm-6" style="padding-left: 0">
                <div
                  class="form-group"
                  [ngClass]="{
                    'has-error': loanFormData.errors.domicileAddress_bldNumber,
                    'has-success':
                      loanFormData.form.controls.domicileAddress_bldNumber.valid
                  }"
                >
                  <label class="help-block">Nomor Blok</label>
                  <p>Isi 0 jika tidak ada</p>

                  <input
                    type="text"
                    class="form-control"
                    name="domicileAddress_bldNumber"
                    formControlName="domicileAddress_bldNumber"
                    id="inp_noBlokKTP"
                    [attr.disabled]="checkInputValid('domicileAddress_bldNumber')"
                  />

                  <p class="help-block">
                    {{ loanFormData.errors.domicileAddress_bldNumber }}
                  </p>
                </div>
              </div>

              <div class="col-xs-6 col-sm-6" style="padding-right: 0">
                <div
                  class="form-group"
                  [ngClass]="{
                    'has-error': loanFormData.errors.domicileAddress_flatNumber,
                    'has-success':
                      loanFormData.form.controls.domicileAddress_flatNumber.valid
                  }"
                >
                  <label class="help-block">Nomor Rumah</label>
                  <p>Isi 0 jika tidak ada</p>

                  <input
                    type="text"
                    class="form-control"
                    name="domicileAddress_flatNumber"
                    formControlName="domicileAddress_flatNumber"
                    id="inp_noRumahKTP"
                    [attr.disabled]="checkInputValid('domicileAddress_flatNumber')"
                  />

                  <p class="help-block">
                    {{ loanFormData.errors.domicileAddress_flatNumber }}
                  </p>
                </div>
              </div>
            </div>

            <div class="row" style="margin: 0">
              <div class="col-xs-6 col-sm-6" style="padding-left: 0">
                <div
                  class="form-group"
                  [ngClass]="{
                    'has-error': loanFormData.errors.domicileAddress_rt,
                    'has-success':
                      loanFormData.form.controls.domicileAddress_rt.valid
                  }"
                >
                  <label class="help-block">RT</label>

                  <input
                    type="text"
                    class="form-control"
                    name="domicileAddress_rt"
                    formControlName="domicileAddress_rt"
                    id="inp_RTKTP"
                    [attr.disabled]="checkInputValid('domicileAddress_rt')"
                  />

                  <p class="help-block">
                    {{ loanFormData.errors.domicileAddress_rt }}
                  </p>
                </div>
              </div>

              <div class="col-xs-6 col-sm-6" style="padding-right: 0">
                <div
                  class="form-group"
                  [ngClass]="{
                    'has-error': loanFormData.errors.domicileAddress_rw,
                    'has-success':
                      loanFormData.form.controls.domicileAddress_rw.valid
                  }"
                >
                  <label class="help-block">RW</label>

                  <input
                    type="text"
                    class="form-control"
                    name="domicileAddress_rw"
                    formControlName="domicileAddress_rw"
                    id="inp_RWKTP"
                    [attr.disabled]="checkInputValid('domicileAddress_rw')"
                  />

                  <p class="help-block">
                    {{ loanFormData.errors.domicileAddress_rw }}
                  </p>
                </div>
              </div>
            </div>

            <div
              class="form-group"
              [ngClass]="{
                'has-error': loanFormData.errors.domicileAddress_province,
                'has-success':
                  loanFormData.form.controls.domicileAddress_province.valid
              }"
            >
              <label class="help-block">Provinsi</label>
              <p>Isi provinsi untuk mengisi kolom-kolom di bawah</p>

              <select
                class="form-control"
                name="domicileAddress_province"
                formControlName="domicileAddress_province"
                id="inp_provinsiKTP"
                (change)="
                  service.getRegions(
                    { province: $event.target.value },
                    'city',
                    'subscribe',
                    null,
                    true
                  )
                "
                [attr.disabled]="checkInputValid('domicileAddress_province')"
              >
                <option value="0">Pilih Salah Satu</option>
                <option
                  *ngFor="let province of loanFormData.provinces"
                  [value]="province.province_id"
                >
                  {{ province.province }}
                </option>
              </select>

              <p
                style="margin-top: 10px"
                *ngIf="loanFormData.provinces.length == 0"
              >
                <span class="glyphicon glyphicon-refresh"></span>
                Sedang mengambil data provinsi...
              </p>

              <p class="help-block">
                {{ loanFormData.errors.domicileAddress_province }}
              </p>
            </div>

            <div
              class="form-group"
              [ngClass]="{
                'has-error': loanFormData.errors.domicileAddress_city,
                'has-success': loanFormData.form.controls.domicileAddress_city.valid
              }"
              [hidden]="loanFormData.cities.length == 0"
            >
              <label class="help-block">Kota</label>

              <select
                [attr.disabled]="checkInputValid('domicileAddress_city')"
                class="form-control"
                name="domicileAddress_city"
                formControlName="domicileAddress_city"
                id="inp_kotaKTP"
                (change)="
                  service.getRegions(
                    {
                      province: loanFormData.form.value.domicileAddress_province,
                      city: $event.target.value
                    },
                    'district',
                    'subscribe',
                    null,
                    true
                  )
                "
              >
                <option value="0">Pilih Salah Satu</option>
                <option
                  *ngFor="let city of loanFormData.cities"
                  [value]="city.city_id"
                >
                  {{ city.city }}
                </option>
              </select>

              <p class="help-block">
                {{ loanFormData.errors.domicileAddress_city }}
              </p>
            </div>

            <div
              class="form-group"
              [ngClass]="{
                'has-error': loanFormData.errors.domicileAddress_district,
                'has-success':
                  loanFormData.form.controls.domicileAddress_district.valid
              }"
              [hidden]="loanFormData.districts.length == 0"
            >
              <label class="help-block">Kecamatan</label>

              <select
                [attr.disabled]="checkInputValid('domicileAddress_district')"
                class="form-control"
                name="domicileAddress_district"
                formControlName="domicileAddress_district"
                id="inp_kecamatanKTP"
                (change)="
                  service.getRegions(
                    {
                      province: loanFormData.form.value.domicileAddress_province,
                      city: loanFormData.form.value.domicileAddress_city,
                      district: $event.target.value
                    },
                    'village',
                    'subscribe',
                    null,
                    true
                  )
                "
              >
                <option value="0">Pilih Salah Satu</option>
                <option
                  *ngFor="let district of loanFormData.districts"
                  [value]="district.district_id"
                >
                  {{ district.district }}
                </option>
              </select>

              <p class="help-block">
                {{ loanFormData.errors.domicileAddress_district }}
              </p>
            </div>

            <div
              class="form-group"
              [ngClass]="{
                'has-error': loanFormData.errors.domicileAddress_village,
                'has-success':
                  loanFormData.form.controls.domicileAddress_village.valid
              }"
              [hidden]="loanFormData.villages.length == 0"
            >
              <label class="help-block">Kelurahan/Desa</label>

              <select
                [attr.disabled]="checkInputValid('domicileAddress_village')"
                class="form-control"
                name="domicileAddress_village"
                formControlName="domicileAddress_village"
                id="inp_kelurahanKTP"
                (change)="
                  service.getRegions(
                    {
                      province: loanFormData.form.value.domicileAddress_province,
                      city: loanFormData.form.value.domicileAddress_city,
                      district: loanFormData.form.value.domicileAddress_district,
                      village: $event.target.value
                    },
                    'postal_code',
                    'subscribe',
                    null,
                    true
                  )
                "
              >
                <option value="0">Pilih Salah Satu</option>
                <option
                  *ngFor="let village of loanFormData.villages"
                  [value]="village.village_id"
                >
                  {{ village.village }}
                </option>
              </select>

              <p class="help-block">
                {{ loanFormData.errors.domicileAddress_village }}
              </p>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="loanFormData.step == 3">
          <div class="loanform__card">
            <h4>Status Tempat Tinggal</h4>

            <div
              class="form-group"
              [ngClass]="{
                'has-error': loanFormData.errors.housing_propertyType,
                'has-success': loanFormData.form.controls.housing_propertyType.valid
              }"
            >
              <label class="help-block">Jenis Tempat Tinggal</label>

              <select
                class="form-control"
                name="housing_propertyType"
                formControlName="housing_propertyType"
                id="inp_jenisTinggal"
              >
                <option value="0">Pilih Salah Satu</option>
                <option value="Apartment">Apartemen</option>
                <option value="House">Rumah</option>
                <option value="HomeStore">Ruko</option>
                <option value="Other">Lainnya</option>
              </select>

              <p class="help-block">
                {{ loanFormData.errors.housing_propertyType }}
              </p>
            </div>

            <div
              class="form-group"
              [ngClass]="{
                'has-error': loanFormData.errors.housing_residentialType,
                'has-success':
                  loanFormData.form.controls.housing_residentialType.valid
              }"
            >
              <label class="help-block">Status Kepemilikan Rumah</label>

              <select
                class="form-control"
                name="housing_residentialType"
                formControlName="housing_residentialType"
                id="inp_statusTinggal"
              >
                <option value="0">Pilih Salah Satu</option>
                <option value="Family">Keluarga</option>
                <option value="BoardingHouse">Kost</option>
                <option value="Parents">Orang Tua</option>
                <option value="OfficeHousing">Rumah Dinas</option>
                <option value="Personal">Sendiri</option>
                <option value="Contract">Sewa/Kontrak</option>
              </select>

              <p class="help-block">
                {{ loanFormData.errors.housing_residentialType }}
              </p>
            </div>

            <div
              class="form-group"
              [ngClass]="{
                'has-error': loanFormData.errors.housing_monthlyCost,
                'has-success': loanFormData.form.controls.housing_monthlyCost.valid
              }"
            >
              <label class="help-block">Sewa/Cicilan per bulan</label>

              <div class="input-group">
                <span class="input-group-addon">Rp</span>

                <input
                  type="tel"
                  class="form-control"
                  name="housing_monthlyCost_show"
                  maxlength="20"
                  formControlName="housing_monthlyCost_show"
                  id="inp_sewaTinggal"
                  [value]="
                    numberDelimiter(loanFormData.form.value.housing_monthlyCost)
                  "
                  (keyup)="
                    handleDelimiter('housing_monthlyCost', $event.target.value)
                  "
                  (keypress)="numericalInputOnly($event)"
                />
              </div>

              <input
                type="hidden"
                name="housing_monthlyCost"
                formControlName="housing_monthlyCost"
                id="inp_sewaTinggal"
              />

              <p class="help-block">
                {{ loanFormData.errors.housing_monthlyCost }}
              </p>
            </div>

            <div
              class="form-group"
              [ngClass]="{
                'has-error': loanFormData.errors.housing_expenseCost,
                'has-success': loanFormData.form.controls.housing_expenseCost.valid
              }"
            >
              <label class="help-block">Biaya PLN & PDAM per Bulan</label>

              <div class="input-group">
                <span class="input-group-addon">Rp</span>

                <input
                  type="tel"
                  class="form-control"
                  name="housing_expenseCost_show"
                  maxlength="20"
                  formControlName="housing_expenseCost_show"
                  id="inp_biayaTinggal"
                  [value]="
                    numberDelimiter(loanFormData.form.value.housing_expenseCost)
                  "
                  (keyup)="
                    handleDelimiter('housing_expenseCost', $event.target.value)
                  "
                  (keypress)="numericalInputOnly($event)"
                />
              </div>

              <input
                type="hidden"
                name="housing_expenseCost"
                formControlName="housing_expenseCost"
                id="inp_biayaTinggal"
              />

              <p class="help-block">
                {{ loanFormData.errors.housing_expenseCost }}
              </p>
            </div>

            <div
              class="form-group"
              [ngClass]="{
                'has-error': loanFormData.errors.housing_numberOfPeople,
                'has-success':
                  loanFormData.form.controls.housing_numberOfPeople.valid
              }"
            >
              <label class="help-block">Jumlah Penghuni</label>
              <p>Masukkan jumlah penghuni tempat tinggal Anda</p>

              <input
                type="tel"
                class="form-control"
                name="housing_numberOfPeople"
                formControlName="housing_numberOfPeople"
                id="inp_jmlTinggalSerumah"
                (keypress)="numericalInputOnly($event)"
              />

              <p class="help-block">
                {{ loanFormData.errors.housing_numberOfPeople }}
              </p>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="loanFormData.step == 3">
          <div class="loanform__card has--subtitle">
            <h4>Alamat Tempat Tinggal</h4>

            <p class="subtitle">
              Pastikan Anda tinggal/bekerja di Area Layanan Kami
            </p>

            <!-- <div class="form-group">
    					<label style="margin-bottom: 10px">Apakah alamat tempat tinggal Anda sama dengan alamat yang tertulis di KTP Anda?</label><br>

    					<button class="tnk__button button--hole button--blue button--margin-sm" (click)="service.setDomicileAsContact(true)" [class.button--active]="!loanFormData.showStep5Form" id="inp_domisiliSama"><span class="icon fa" [ngClass]="{'fa-circle-thin': loanFormData.showStep5Form, 'fa-check-circle': !loanFormData.showStep5Form}"></span> Sama</button>

    					<button class="tnk__button button--hole button--blue button--margin-sm" (click)="service.setDomicileAsContact(false)" [class.button--active]="loanFormData.showStep5Form" id="inp_domisiliBeda"><span class="icon fa" [ngClass]="{'fa-circle-thin': !loanFormData.showStep5Form, 'fa-check-circle': loanFormData.showStep5Form}"></span> Berbeda</button>

    					<hr>

    					<p class="bold">
    						- Tidak masalah alamat tinggal berbeda dengan KTP<br>
    						- Pastikan Anda tinggal/bekerja di Area Layanan Kami
    					</p>
    				</div> -->

            <ng-container>
              <div
                class="form-group"
                [ngClass]="{
                  'has-error': loanFormData.errors.contactAddress_street,
                  'has-success':
                    loanFormData.form.controls.contactAddress_street.valid
                }"
              >
                <hr />

                <label class="help-block">Alamat Tempat Tinggal</label>

                <input
                  type="text"
                  class="form-control"
                  name="contactAddress_street"
                  formControlName="contactAddress_street"
                  id="inp_alamatKTPTinggal"
                />

                <p class="help-block">
                  {{ loanFormData.errors.contactAddress_street }}
                </p>
              </div>

              <div class="row" style="margin: 0">
                <div class="col-xs-6 col-sm-6" style="padding-left: 0">
                  <div
                    class="form-group"
                    [ngClass]="{
                      'has-error': loanFormData.errors.contactAddress_bldNumber,
                      'has-success':
                        loanFormData.form.controls.contactAddress_bldNumber.valid
                    }"
                  >
                    <label class="help-block">Nomor Blok</label>
                    <p>Isi 0 jika tidak ada</p>

                    <input
                      type="text"
                      class="form-control"
                      name="contactAddress_bldNumber"
                      formControlName="contactAddress_bldNumber"
                      id="inp_noBlokKTPTinggal"
                    />

                    <p class="help-block">
                      {{ loanFormData.errors.contactAddress_bldNumber }}
                    </p>
                  </div>
                </div>

                <div class="col-xs-6 col-sm-6" style="padding-right: 0">
                  <div
                    class="form-group"
                    [ngClass]="{
                      'has-error': loanFormData.errors.contactAddress_flatNumber,
                      'has-success':
                        loanFormData.form.controls.contactAddress_flatNumber.valid
                    }"
                  >
                    <label class="help-block">Nomor Rumah</label>
                    <p>Isi 0 jika tidak ada</p>

                    <input
                      type="text"
                      class="form-control"
                      name="contactAddress_flatNumber"
                      formControlName="contactAddress_flatNumber"
                      id="inp_noRumahKTPTinggal"
                    />

                    <p class="help-block">
                      {{ loanFormData.errors.contactAddress_flatNumber }}
                    </p>
                  </div>
                </div>
              </div>

              <div class="row" style="margin: 0">
                <div class="col-xs-6 col-sm-6" style="padding-left: 0">
                  <div
                    class="form-group"
                    [ngClass]="{
                      'has-error': loanFormData.errors.contactAddress_rt,
                      'has-success':
                        loanFormData.form.controls.contactAddress_rt.valid
                    }"
                  >
                    <label class="help-block">RT</label>

                    <input
                      type="tel"
                      class="form-control"
                      name="contactAddress_rt"
                      formControlName="contactAddress_rt"
                      id="inp_RTKTPTinggal"
                      (keypress)="numericalInputOnly($event)"
                    />

                    <p class="help-block">
                      {{ loanFormData.errors.contactAddress_rt }}
                    </p>
                  </div>
                </div>

                <div class="col-xs-6 col-sm-6" style="padding-right: 0">
                  <div
                    class="form-group"
                    [ngClass]="{
                      'has-error': loanFormData.errors.contactAddress_rw,
                      'has-success':
                        loanFormData.form.controls.contactAddress_rw.valid
                    }"
                  >
                    <label class="help-block">RW</label>

                    <input
                      type="tel"
                      class="form-control"
                      name="contactAddress_rw"
                      formControlName="contactAddress_rw"
                      id="inp_RWKTPTinggal"
                      (keypress)="numericalInputOnly($event)"
                    />

                    <p class="help-block">
                      {{ loanFormData.errors.contactAddress_rw }}
                    </p>
                  </div>
                </div>
              </div>

              <div
                class="form-group"
                [ngClass]="{
                  'has-error': loanFormData.errors.contactAddress_province,
                  'has-success':
                    loanFormData.form.controls.contactAddress_province.valid
                }"
              >
                <label class="help-block">Provinsi</label>
                <p>Isi provinsi untuk mengisi kolom-kolom di bawah</p>

                <select
                  class="form-control"
                  name="contactAddress_province"
                  formControlName="contactAddress_province"
                  id="inp_provinsiKTPTinggal"
                  (change)="
                    service.getRegions(
                      { province: $event.target.value },
                      'city',
                      'subscribe',
                      'contact',
                      true
                    )
                  "
                >
                  <option value="0">Pilih Salah Satu</option>
                  <option
                    *ngFor="let province of loanFormData.provinces"
                    [value]="province.province_id"
                  >
                    {{ province.province }}
                  </option>
                </select>

                <p class="help-block">
                  {{ loanFormData.errors.contactAddress_province }}
                </p>
              </div>

              <div
                class="form-group"
                [ngClass]="{
                  'has-error': loanFormData.errors.contactAddress_city,
                  'has-success':
                    loanFormData.form.controls.contactAddress_city.valid
                }"
                [hidden]="loanFormData.citiesContact.length == 0"
              >
                <label class="help-block">Kota</label>

                <select
                  class="form-control"
                  name="contactAddress_city"
                  formControlName="contactAddress_city"
                  id="inp_kotaKTPTinggal"
                  (change)="
                    service.getRegions(
                      {
                        province: loanFormData.form.value.contactAddress_province,
                        city: $event.target.value
                      },
                      'district',
                      'subscribe',
                      'contact',
                      true
                    )
                  "
                >
                  <option value="0">Pilih Salah Satu</option>
                  <option
                    *ngFor="let city of loanFormData.citiesContact"
                    [value]="city.city_id"
                  >
                    {{ city.city }}
                  </option>
                </select>

                <p class="help-block">
                  {{ loanFormData.errors.contactAddress_city }}
                </p>
              </div>

              <div
                class="form-group"
                [ngClass]="{
                  'has-error': loanFormData.errors.contactAddress_district,
                  'has-success':
                    loanFormData.form.controls.contactAddress_district.valid
                }"
                [hidden]="loanFormData.districtsContact.length == 0"
              >
                <label class="help-block">Kecamatan</label>

                <select
                  class="form-control"
                  name="contactAddress_district"
                  formControlName="contactAddress_district"
                  id="inp_kecamatanKTPTinggal"
                  (change)="
                    service.getRegions(
                      {
                        province: loanFormData.form.value.contactAddress_province,
                        city: loanFormData.form.value.contactAddress_city,
                        district: $event.target.value
                      },
                      'village',
                      'subscribe',
                      'contact',
                      true
                    )
                  "
                >
                  <option value="0">Pilih Salah Satu</option>
                  <option
                    *ngFor="let district of loanFormData.districtsContact"
                    [value]="district.district_id"
                  >
                    {{ district.district }}
                  </option>
                </select>

                <p class="help-block">
                  {{ loanFormData.errors.contactAddress_district }}
                </p>
              </div>

              <div
                class="form-group"
                [ngClass]="{
                  'has-error': loanFormData.errors.contactAddress_village,
                  'has-success':
                    loanFormData.form.controls.contactAddress_village.valid
                }"
                [hidden]="loanFormData.villagesContact.length == 0"
              >
                <label class="help-block">Kelurahan/Desa</label>

                <select
                  class="form-control"
                  name="contactAddress_village"
                  formControlName="contactAddress_village"
                  id="inp_kelurahanKTPTinggal"
                  (change)="
                    service.getRegions(
                      {
                        province: loanFormData.form.value.contactAddress_province,
                        city: loanFormData.form.value.contactAddress_city,
                        district: loanFormData.form.value.contactAddress_district,
                        village: $event.target.value
                      },
                      'postal_code',
                      'subscribe',
                      'contact',
                      true
                    )
                  "
                >
                  <option value="0">Pilih Salah Satu</option>
                  <option
                    *ngFor="let village of loanFormData.villagesContact"
                    [value]="village.village_id"
                  >
                    {{ village.village }}
                  </option>
                </select>

                <p class="help-block">
                  {{ loanFormData.errors.contactAddress_village }}
                </p>
              </div>
            </ng-container>
          </div>
        </ng-container>

        <ng-container *ngIf="loanFormData.step == 4">
          <div class="loanform__card has--subtitle">
            <h4>Pekerjaan Saat Ini</h4>
            <p class="subtitle bold">
              Kami akan melakukan tanda tangan kontrak dengan kurir ke tempat kerja
              Anda
            </p>

            <div
              class="form-group"
              [ngClass]="{
                'has-error': loanFormData.errors.income_jobType,
                'has-success': loanFormData.form.controls.income_jobType.valid
              }"
            >
              <label class="help-block">Jenis Pekerjaan</label>

              <select
                class="form-control"
                id="inp_jenisKerja"
                name="income_jobType"
                formControlName="income_jobType"
              >
                <option value="0">Pilih Salah Satu</option>
                <option value="PublicServant">PNS</option>
                <option value="PrivateEmployee">Swasta</option>
                <option value="RetiredPublicServant">Pensiunan PNS</option>
                <option value="Retired">Pensiunan Biasa</option>
                <option value="MilitaryPolice">TNI/Polri</option>
                <option value="Entrepreneur">Wiraswasta</option>
                <option value="Student">Pelajar</option>
                <option value="Unemployed">Tidak Bekerja</option>
                <option value="Other">Lainnya</option>
              </select>

              <p class="help-block">{{ loanFormData.errors.income_jobType }}</p>
            </div>

            <!-- Loan purpose Entrepreneur -->
            <div
              class="form-group"
              *ngIf="
                loanFormData.form.value.loanPurpose === 'VentureCapital' &&
                loanFormData.form.value.income_jobType === 'Entrepreneur'
              "
            >
              <label class="help-block">
                Bagaimana Anda Menggunakan Dana Pinjaman yang Akan Anda Terima?
              </label>

              <select
                class="form-control"
                name="income_loanPurposeOfWorkingCapital"
                formControlName="income_loanPurposeOfWorkingCapital"
                id="inp_loanPurposeOfWorkingCapital"
              >
                <option value="">Pilih Salah Satu</option>
                <option
                  value="{{ LOAN_PURPOSE_ENTREPRENEUR.BUY_MORE_INVENTORIES }}"
                >
                  Menambah persediaan/menambah barang
                </option>
                <option
                  value="{{ LOAN_PURPOSE_ENTREPRENEUR.PAY_SHOP_OR_OUTLET_RENTAL }}"
                >
                  Membayar sewa tempat/toko/gedung
                </option>
                <option
                  value="{{ LOAN_PURPOSE_ENTREPRENEUR.RENOVATE_SHOP_OR_OUTLET }}"
                >
                  Renovasi tempat/toko/gedung
                </option>
                <option
                  value="{{ LOAN_PURPOSE_ENTREPRENEUR.EXPAND_OR_ADD_MORE_SHOP }}"
                >
                  Membuka/menambah usaha baru
                </option>
                <option value="{{ LOAN_PURPOSE_ENTREPRENEUR.PAY_BACK_LOANS }}">
                  Membayar pinjaman lainnya
                </option>
                <option
                  value="{{ LOAN_PURPOSE_ENTREPRENEUR.RECRUIT_MORE_EMPLOYEES }}"
                >
                  Membayar/menambah karyawan
                </option>
              </select>

              <p class="help-block">
                {{ loanFormData.errors.contactAddress_province }}
              </p>
            </div>
            <!-- End of Loan purpose Entrepreneur -->

            <section
              [hidden]="
                loanFormData.form.value.income_jobType != 'PublicServant' &&
                loanFormData.form.value.income_jobType != 'PrivateEmployee' &&
                loanFormData.form.value.income_jobType != 'MilitaryPolice'
              "
            >
              <div
                class="form-group"
                [ngClass]="{
                  'has-error': loanFormData.errors.income_employmentStatus,
                  'has-success':
                    loanFormData.form.controls.income_employmentStatus.valid
                }"
              >
                <label class="help-block">Status Pekerjaan</label>

                <select
                  class="form-control"
                  id="inp_statusKerja"
                  name="income_employmentStatus"
                  formControlName="income_employmentStatus"
                >
                  <option value="0">Pilih Salah Satu</option>
                  <option value="Permanent">Permanen</option>
                  <option value="Contract">Kontrak</option>
                  <option value="Daily">Lepas/Harian</option>
                </select>

                <p class="help-block">
                  {{ loanFormData.errors.income_employmentStatus }}
                </p>
              </div>

              <div
                class="form-group"
                [ngClass]="{
                  'has-error': loanFormData.errors.income_employerName,
                  'has-success':
                    loanFormData.form.controls.income_employerName.valid
                }"
              >
                <label class="help-block">
                  Nama Perusahaan / Nama usaha jika Anda pengusaha
                </label>
                <!-- <p>Nama usaha jika Anda pengusaha</p> -->

                <input
                  type="text"
                  class="form-control"
                  name="income_employerName"
                  formControlName="income_employerName"
                  id="inp_namaPerusahaan"
                  maxlength="80"
                />

                <p class="text__length">
                  {{
                    loanFormData.form.controls.income_employerName.value
                      ? loanFormData.form.controls.income_employerName.value.length
                      : 0
                  }}/80
                </p>

                <p class="help-block">
                  {{ loanFormData.errors.income_employerName }}
                </p>
              </div>

              <!-- <div class="form-group" [ngClass]="{'has-error': loanFormData.errors.contactAddress_province, 'has-success': loanFormData.form.controls.contactAddress_province.valid}">
    						<label class="help-block">Bidang Usaha</label>

    						<select class="form-control" name="contactAddress_province" formControlName="contactAddress_province" id="inp_bidangUsaha">
    							<option value="0">Pilih Salah Satu</option>
    							<option value="1">Perbankan/Akunting</option>
    							<option value="2">Telekomunikasi</option>
    							<option value="3">Jasa</option>
    							<option value="4">Perdagangan/Distributor</option>
    							<option value="5">Manufaktur</option>
    							<option value="99">Lainnya</option>
    						</select>

    						<p class="help-block">{{loanFormData.errors.contactAddress_province}}</p>
    					</div> -->

              <div
                class="form-group"
                [ngClass]="{
                  'has-error': loanFormData.errors.income_workPosition,
                  'has-success':
                    loanFormData.form.controls.income_workPosition.valid
                }"
              >
                <label class="help-block">Jabatan di Perusahaan</label>

                <select
                  class="form-control"
                  name="income_workPosition"
                  formControlName="income_workPosition"
                  id="inp_jabatan"
                >
                  <option value="0">Pilih Salah Satu</option>
                  <option value="Contract">Kontrak</option>
                  <option value="Staff">Staff</option>
                  <option value="Supervisor">Supervisor</option>
                  <option value="JuniorManagement">Manajemen Junior</option>
                  <option value="MiddleManagement">Manajemen Menengah</option>
                  <option value="SeniorManagement">Manajemen Senior</option>
                </select>

                <p class="help-block">
                  {{ loanFormData.errors.income_workPosition }}
                </p>
              </div>

              <div
                class="form-group"
                [ngClass]="{
                  'has-error': loanFormData.errors.income_monthlyIncome,
                  'has-success':
                    loanFormData.form.controls.income_monthlyIncome.valid
                }"
              >
                <label class="help-block">Penghasilan Bulanan Saat Ini</label>
                <p>Pendapatan pekerjaan/usaha saat ini (Tidak harus UMR)</p>

                <div class="input-group">
                  <span class="input-group-addon">Rp</span>

                  <input
                    type="tel"
                    class="form-control"
                    name="income_monthlyIncome_show"
                    maxlength="20"
                    formControlName="income_monthlyIncome_show"
                    id="inp_gaji"
                    [value]="
                      numberDelimiter(loanFormData.form.value.income_monthlyIncome)
                    "
                    (keyup)="
                      handleDelimiter('income_monthlyIncome', $event.target.value)
                    "
                    (keypress)="numericalInputOnly($event)"
                  />
                </div>

                <input
                  type="hidden"
                  name="income_monthlyIncome"
                  formControlName="income_monthlyIncome"
                  id="inp_gaji"
                />

                <p class="help-block">
                  {{ loanFormData.errors.income_monthlyIncome }}
                </p>
              </div>

              <div
                class="form-group"
                [ngClass]="{
                  'has-error': loanFormData.errors.income_previousIncome,
                  'has-success':
                    loanFormData.form.controls.income_previousIncome.valid
                }"
              >
                <label class="help-block">Penghasilan Bulanan Sebelumnya</label>
                <p>Pendapatan pekerjaan, posisi atau tahun sebelumnya</p>

                <div class="input-group">
                  <span class="input-group-addon">Rp</span>

                  <input
                    type="tel"
                    class="form-control"
                    name="income_previousIncome_show"
                    maxlength="20"
                    formControlName="income_previousIncome_show"
                    id="inp_gajiSebelumnya"
                    [value]="
                      numberDelimiter(loanFormData.form.value.income_previousIncome)
                    "
                    (keyup)="
                      handleDelimiter('income_previousIncome', $event.target.value)
                    "
                    (keypress)="numericalInputOnly($event)"
                  />
                </div>

                <input
                  type="hidden"
                  name="income_previousIncome"
                  formControlName="income_previousIncome"
                  id="inp_gajiSebelumnya"
                />

                <p class="help-block">
                  {{ loanFormData.errors.income_previousIncome }}
                </p>
              </div>
            </section>
          </div>

          <!-- Start of Entrepreneur Form -->
          <div
            class="loanform__card has--subtitle"
            *ngIf="loanFormData.form.value.income_jobType === 'Entrepreneur'"
          >
            <h4>Detail Bisnis</h4>
            <div
              class="form-group"
              [ngClass]="{
                'has-error': loanFormData.errors.income_businessName,
                'has-success': loanFormData.form.controls.income_businessName.valid
              }"
            >
              <label class="help-block">Apa Nama Bisnis Anda Saat Ini?</label>
              <input
                type="text"
                class="form-control"
                name="income_businessName"
                formControlName="income_businessName"
                id="inp_businessName"
                maxlength="80"
              />
              <p class="help-block">
                {{ loanFormData.errors.income_businessName }}
              </p>
            </div>

            <div
              class="form-group"
              [ngClass]="{
                'has-error': loanFormData.errors.income_businessType,
                'has-success': loanFormData.form.controls.income_businessType.valid
              }"
            >
              <label class="help-block">Jenis Bisnis Apa yang Anda Jalani?</label>

              <select
                class="form-control"
                name="income_businessType"
                formControlName="income_businessType"
                id="inp_businessType"
              >
                <option value="0">Pilih Salah Satu</option>
                <option value="{{ BUSINESS_TYPE_ENTREPRENEUR.FOOD }}">
                  Makanan
                </option>
                <option value="{{ BUSINESS_TYPE_ENTREPRENEUR.RETAIL_TRADING }}">
                  Retail
                </option>
                <option value="{{ BUSINESS_TYPE_ENTREPRENEUR.CLOTHES_TRADING }}">
                  Pakaian
                </option>
                <option value="{{ BUSINESS_TYPE_ENTREPRENEUR.SERVICES }}">
                  Servis / Jasa
                </option>
                <option value="{{ BUSINESS_TYPE_ENTREPRENEUR.OTHERS }}">
                  Lain-lain
                </option>
              </select>
              <p class="help-block">
                {{ loanFormData.errors.income_businessType }}
              </p>
            </div>

            <div
              class="form-group"
              [ngClass]="{
                'has-error': loanFormData.errors.income_businessAge,
                'has-success': loanFormData.form.controls.income_businessAge.valid
              }"
            >
              <label class="help-block">
                Sudah Berapa Lama Bisnis Anda Berjalan?
              </label>

              <select
                class="form-control"
                name="income_businessAge"
                formControlName="income_businessAge"
                id="inp_businessAge"
              >
                <option value="0">Pilih Salah Satu</option>
                <option value="{{ BUSINESS_AGE_ENTREPRENEUR.LESS_THAN_ONE_YEAR }}">
                  Kurang dari satu tahun
                </option>
                <option value="{{ BUSINESS_AGE_ENTREPRENEUR.MORE_THAN_ONE_YEAR }}">
                  1 - 3 tahun
                </option>
                <option
                  value="{{ BUSINESS_AGE_ENTREPRENEUR.MORE_THAN_THREE_YEARS }}"
                >
                  3 - 5 tahun
                </option>
                <option
                  value="{{ BUSINESS_AGE_ENTREPRENEUR.MORE_THAN_FIVE_YEARS }}"
                >
                  5 - 10 tahun
                </option>
                <option value="{{ BUSINESS_AGE_ENTREPRENEUR.MORE_THAN_TEN_YEARS }}">
                  lebih dari 10 tahun
                </option>
              </select>
              <p class="help-block">
                {{ loanFormData.errors.income_businessAge }}
              </p>
            </div>

            <div
              class="form-group"
              [ngClass]="{
                'has-error': loanFormData.errors.income_businessIncome,
                'has-success':
                  loanFormData.form.controls.income_businessIncome.valid
              }"
            >
              <label class="help-block">
                Berapa Rata-Rata Keuntungan Bisnis Anda Setiap Bulannya?
              </label>
              <p>Jumlah pendapatan dari usaha atau toko Anda</p>

              <div class="input-group">
                <span class="input-group-addon">Rp</span>
                <input
                  type="tel"
                  class="form-control"
                  name="income_businessIncome_show"
                  maxlength="20"
                  formControlName="income_businessIncome_show"
                  id="inp_businessIncome"
                  [value]="
                    numberDelimiter(loanFormData.form.value.income_businessIncome)
                  "
                  (keyup)="
                    handleDelimiter('income_businessIncome', $event.target.value)
                  "
                  (keypress)="numericalInputOnly($event)"
                />
              </div>

              <input
                type="hidden"
                name="income_businessIncome"
                formControlName="income_businessIncome"
                id="inp_businessIncome"
              />

              <p class="help-block">
                {{ loanFormData.errors.income_businessIncome }}
              </p>
            </div>
          </div>

          <div
            class="loanform__card has--subtitle"
            *ngIf="loanFormData.form.value.income_jobType === 'Entrepreneur'"
          >
            <div
              class="form-group"
              [ngClass]="{
                'has-error': loanFormData.errors.income_businessPromotion,
                'has-success':
                  loanFormData.form.controls.income_businessPromotion.valid
              }"
            >
              <label class="help-block">
                Bagaimana Cara Anda Menjalankan Bisnis Anda?
              </label>

              <select
                class="form-control"
                name="income_businessPromotion"
                formControlName="income_businessPromotion"
                id="inp_businessPromotion"
              >
                <option value="0">Pilih Salah Satu</option>
                <option
                  value="{{ BUSINESS_PROMOTION_ENTREPRENEUR.MOSTLY_OFFLINE }}"
                >
                  Offline (usaha di tempat)
                </option>
                <option value="{{ BUSINESS_PROMOTION_ENTREPRENEUR.MOSTLY_ONLINE }}">
                  Online (usaha menggunakan social media atau ecommerce)
                </option>
                <option value="{{ BUSINESS_PROMOTION_ENTREPRENEUR.BOTH }}">
                  Keduanya
                </option>
              </select>

              <p class="help-block">
                {{ loanFormData.errors.income_businessPromotion }}
              </p>
            </div>

            <!-- Will shown if option above is online or both -->
            <div
              class="form-group"
              *ngIf="
                loanFormData.form.value.income_businessPromotion ===
                  BUSINESS_PROMOTION_ENTREPRENEUR.MOSTLY_ONLINE ||
                loanFormData.form.value.income_businessPromotion ===
                  BUSINESS_PROMOTION_ENTREPRENEUR.BOTH
              "
            >
              <label class="help-block">
                Dimana Anda Menjalankan Bisnis Online Anda?
              </label>

              <select
                class="form-control"
                id="inp_onlineChannel"
                name="income_onlineChannel"
                formControlName="income_onlineChannel"
              >
                <option value="">Pilih Salah Satu</option>
                <option value="{{ ONLINE_CHANNEL_ENTREPRENEUR.TOKOPEDIA }}">
                  Tokopedia
                </option>
                <option value="{{ ONLINE_CHANNEL_ENTREPRENEUR.LAZADA }}">
                  Lazada
                </option>
                <option value="{{ ONLINE_CHANNEL_ENTREPRENEUR.SHOPEE }}">
                  Shopee
                </option>
                <option value="{{ ONLINE_CHANNEL_ENTREPRENEUR.BUKALAPAK }}">
                  Bukalapak
                </option>
                <option value="{{ ONLINE_CHANNEL_ENTREPRENEUR.INSTAGRAM }}">
                  Instagram
                </option>
                <option value="{{ ONLINE_CHANNEL_ENTREPRENEUR.OWN_WEBSITE }}">
                  Memiliki website sendiri
                </option>
                <option value="{{ ONLINE_CHANNEL_ENTREPRENEUR.OTHER }}">
                  Lain-lain
                </option>
              </select>
            </div>

            <div
              class="form-group"
              [ngClass]="{
                'has-error': loanFormData.errors.income_businessPlace,
                'has-success': loanFormData.form.controls.income_businessPlace.valid
              }"
            >
              <label class="help-block">
                Dimana Anda Menjalankan Bisnis Tersebut?
              </label>

              <select
                class="form-control"
                name="income_businessPlace"
                formControlName="income_businessPlace"
                id="inp_businessPlace"
              >
                <option value="0">Pilih Salah Satu</option>
                <option value="{{ BUSINESS_PLACE_ENTREPRENEUR.OWN_HOUSE }}">
                  Rumah sendiri
                </option>
                <option value="{{ BUSINESS_PLACE_ENTREPRENEUR.RENT_RUKO }}">
                  Sewa tempat (sewa lapak, ruko atau rumah)
                </option>
                <option value="{{ BUSINESS_PLACE_ENTREPRENEUR.OWN_RUKO }}">
                  Memiliki ruko/bangunan khusus usaha
                </option>
                .
              </select>
              <p class="help-block">
                {{ loanFormData.errors.income_businessPlace }}
              </p>
            </div>

            <div
              class="form-group"
              *ngIf="
                loanFormData.form.value.income_businessPlace ===
                BUSINESS_PLACE_ENTREPRENEUR.RENT_RUKO
              "
            >
              <label class="help-block">
                Berapa Biaya Sewa per Bulan Tempat Bisnis Anda?
              </label>
              <p>Isi dengan angka, contoh 1000000</p>

              <div class="input-group">
                <span class="input-group-addon">Rp</span>
                <input
                  type="tel"
                  class="form-control"
                  name="income_rentalCosts_show"
                  maxlength="20"
                  formControlName="income_rentalCosts_show"
                  id="inp_rentalCosts"
                  [value]="
                    numberDelimiter(loanFormData.form.value.income_rentalCosts)
                  "
                  (keyup)="
                    handleDelimiter('income_rentalCosts', $event.target.value)
                  "
                  (keypress)="numericalInputOnly($event)"
                />
              </div>

              <input
                type="hidden"
                name="income_rentalCosts"
                formControlName="income_rentalCosts"
                id="inp_rentalCosts"
              />
            </div>

            <div
              class="form-group"
              [ngClass]="{
                'has-error': loanFormData.errors.income_numberOfEmployees,
                'has-success':
                  loanFormData.form.controls.income_numberOfEmployees.valid
              }"
            >
              <label class="help-block">
                Berapa Banyak Pegawai yang Membantu Bisnis Anda?
              </label>

              <select
                class="form-control"
                name="income_numberOfEmployees"
                formControlName="income_numberOfEmployees"
                id="inp_numberOfEmployees"
              >
                <option value="0">Pilih Salah Satu</option>
                <option
                  value="{{ NUMBER_OF_EMPLOYEES_ENTREPRENEUR.RUN_BY_MYSELF }}"
                >
                  Saya menjalankan bisnis/usaha saya sendiri
                </option>
                <option
                  value="{{
                    NUMBER_OF_EMPLOYEES_ENTREPRENEUR.HELPED_BY_FAMILY_MEMBERS
                  }}"
                >
                  Dibantu oleh keluarga
                </option>
                <option
                  value="{{ NUMBER_OF_EMPLOYEES_ENTREPRENEUR.ONE_TO_FIVE_PEOPLE }}"
                >
                  Dibantu 1-5 karyawan
                </option>
                <option
                  value="{{ NUMBER_OF_EMPLOYEES_ENTREPRENEUR.FIVE_TO_TEN_PEOPLE }}"
                >
                  Dibantu 6-10 karyawan
                </option>
                <option
                  value="{{
                    NUMBER_OF_EMPLOYEES_ENTREPRENEUR.MORE_THAN_TEN_PEOPLE
                  }}"
                >
                  Dibantu lebih dari 10 karyawan
                </option>
              </select>
              <p class="help-block">
                {{ loanFormData.errors.income_numberOfEmployees }}
              </p>
            </div>

            <div
              class="form-group"
              *ngIf="
                loanFormData.form.value.income_numberOfEmployees ===
                NUMBER_OF_EMPLOYEES_ENTREPRENEUR.HELPED_BY_FAMILY_MEMBERS
              "
            >
              <label class="help-block">
                Berapa Banyak Anggota Keluarga yang Membantu Menjalankan Bisnis
                Anda?
              </label>

              <select
                class="form-control"
                name="income_helpedByFamilyMembers"
                formControlName="income_helpedByFamilyMembers"
                id="inp_helpedByFamilyMembers"
              >
                <option value="">Pilih Salah Satu</option>
                <option value="{{ HELPED_BY_FAMILY_MEMBERS.ONE_TO_THREE }}">
                  1 - 3 orang
                </option>
                <option value="{{ HELPED_BY_FAMILY_MEMBERS.FOUR_TO_FIVE }}">
                  4 - 5 orang
                </option>
                <option value="{{ HELPED_BY_FAMILY_MEMBERS.MORE_THAN_FIVE }}">
                  lebih dari 5
                </option>
              </select>
            </div>
          </div>
          <!-- End of Entrepreneur Form -->
        </ng-container>

        <ng-container *ngIf="loanFormData.step == 5">
          <div class="loanform__card">
            <h4>Status Pernikahan</h4>

            <div
              class="form-group"
              [ngClass]="{
                'has-error': loanFormData.errors.maritalStatusType,
                'has-success': loanFormData.form.controls.maritalStatusType.valid
              }"
            >
              <label class="help-block">Status Pernikahan</label>

              <select
                class="form-control"
                id="inp_statusNikah"
                name="maritalStatusType"
                formControlName="maritalStatusType"
              >
                <option value="0">Pilih Salah Satu</option>
                <option value="Single">Belum Menikah</option>
                <option value="Married">Menikah</option>
                <option value="Divorced">Cerai</option>
              </select>

              <p class="help-block">{{ loanFormData.errors.maritalStatusType }}</p>
            </div>

            <section
              [hidden]="loanFormData.form.value.maritalStatusType != 'Married'"
            >
              <div
                class="form-group"
                [ngClass]="{
                  'has-error': loanFormData.errors.spouse_pin,
                  'has-success': loanFormData.form.controls.spouse_pin.valid
                }"
              >
                <label class="help-block">Nomor KTP Pasangan</label>

                <input
                  type="tel"
                  class="form-control"
                  name="spouse_pin"
                  id="inp_ktpPasangan"
                  formControlName="spouse_pin"
                  (blur)="service.spouseDob($event.target.value)"
                  (keypress)="numericalInputOnly($event)"
                />

                <p class="help-block">{{ loanFormData.errors.spouse_pin }}</p>
              </div>

              <div
                class="form-group"
                [ngClass]="{
                  'has-error': loanFormData.errors.spouse_name,
                  'has-success': loanFormData.form.controls.spouse_name.valid
                }"
              >
                <label class="help-block">Nama Pasangan</label>

                <input
                  type="text"
                  class="form-control"
                  name="spouse_name"
                  id="inp_namaPasangan"
                  formControlName="spouse_name"
                />

                <p class="help-block">{{ loanFormData.errors.spouse_name }}</p>
              </div>

              <div
                class="form-group"
                [ngClass]="{
                  'has-error': loanFormData.errors.spouse_dateOfBirth,
                  'has-success': loanFormData.form.controls.spouse_dateOfBirth.valid
                }"
              >
                <label class="help-block">Tanggal Lahir Pasangan</label>

                <date-dropdown
                  #spouseDob
                  [dob]="loanFormData.form.value.spouse_dateOfBirth"
                  [bindForm]="loanFormData.form"
                  [bindControlName]="'spouse_dateOfBirth'"
                  (dateModel)="service.setBirthDate($event, 'spouse')"
                ></date-dropdown>

                <p class="help-block">
                  {{ loanFormData.errors.spouse_dateOfBirth }}
                </p>
              </div>

              <div
                class="form-group"
                [ngClass]="{
                  'has-error': loanFormData.errors.spouse_splitAssetAgreement,
                  'has-success':
                    loanFormData.form.controls.spouse_splitAssetAgreement.valid
                }"
              >
                <label class="help-block">
                  Apakah Anda dan pasangan Anda pisah harta?
                </label>

                <button
                  id="inp_yaPisahHarta"
                  class="tnk__button button--hole button--blue button--margin-sm"
                  [class.button--active]="
                    loanFormData.form.value.spouse_splitAssetAgreement == 'Y'
                  "
                  (click)="
                    loanFormData.form.patchValue({
                      spouse_splitAssetAgreement: 'Y'
                    })
                  "
                >
                  <span
                    class="icon fa"
                    [ngClass]="{
                      'fa-circle-thin':
                        loanFormData.form.value.spouse_splitAssetAgreement != 'Y',
                      'fa-check-circle':
                        loanFormData.form.value.spouse_splitAssetAgreement == 'Y'
                    }"
                  ></span>
                  Ya, Pisah
                </button>

                <button
                  id="inp_tidakPisahHarta"
                  class="tnk__button button--hole button--blue button--margin-sm"
                  [class.button--active]="
                    loanFormData.form.value.spouse_splitAssetAgreement == 'N'
                  "
                  (click)="
                    loanFormData.form.patchValue({
                      spouse_splitAssetAgreement: 'N'
                    })
                  "
                >
                  <span
                    class="icon fa"
                    [ngClass]="{
                      'fa-circle-thin':
                        loanFormData.form.value.spouse_splitAssetAgreement != 'N',
                      'fa-check-circle':
                        loanFormData.form.value.spouse_splitAssetAgreement == 'N'
                    }"
                  ></span>
                  Tidak, Campur
                </button>
              </div>
            </section>
          </div>

          <div class="loanform__card has--subtitle">
            <h4>Data Kerabat</h4>
            <p class="subtitle">
              Masukkan data kontak kerabat terdekat (sepupu, saudara, atau keluarga)
              sebaiknya yang tidak serumah
            </p>

            <div
              class="form-group"
              [ngClass]="{
                'has-error': loanFormData.errors.personalReference_name,
                'has-success':
                  loanFormData.form.controls.personalReference_name.valid
              }"
            >
              <label class="help-block">Nama Kerabat</label>

              <input
                type="text"
                class="form-control"
                id="inp_namaKerabat"
                name="personalReference_name"
                formControlName="personalReference_name"
              />

              <p class="help-block">
                {{ loanFormData.errors.personalReference_name }}
              </p>
            </div>

            <div
              class="form-group"
              [ngClass]="{
                'has-error': loanFormData.errors.personalReference_mobilePhone,
                'has-success':
                  loanFormData.form.controls.personalReference_mobilePhone.valid
              }"
            >
              <label class="help-block">Nomor Handphone Kerabat</label>

              <div class="input-group">
                <span class="input-group-addon">+62</span>

                <input
                  type="tel"
                  class="form-control"
                  id="inp_HPKerabat"
                  name="personalReference_mobilePhone"
                  formControlName="personalReference_mobilePhone"
                  (keypress)="numericalInputOnly($event)"
                />
              </div>

              <p class="help-block">
                {{ loanFormData.errors.personalReference_mobilePhone }}
              </p>
            </div>

            <div
              class="form-group"
              [ngClass]="{
                'has-error': loanFormData.errors.personalReference_address,
                'has-success':
                  loanFormData.form.controls.personalReference_address.valid
              }"
            >
              <label class="help-block">Alamat Lengkap Kerabat</label>

              <input
                type="text"
                class="form-control"
                id="inp_alamatKerabat"
                name="personalReference_address"
                formControlName="personalReference_address"
              />

              <p class="help-block">
                {{ loanFormData.errors.personalReference_address }}
              </p>
            </div>
            <div
              class="form-group"
              [ngClass]="{
                'has-error': loanFormData.errors.educationType,
                'has-success': loanFormData.form.controls.educationType.valid
              }"
            >
              <label class="help-block">Tingkat Pendidikan Terakhir</label>

              <select
                class="form-control"
                name="educationType"
                formControlName="educationType"
                id="inp_tingkatPendidikan"
              >
                <option value="0">Pilih salah satu</option>
                <option value="Elementary">SD</option>
                <option value="JuniorHighSchool">SMP</option>
                <option value="HighSchool">SMA</option>
                <option value="Diploma">Diploma</option>
                <option value="BachelorDegree">S1</option>
                <option value="Master">S2</option>
                <option value="PostGraduate">S3</option>
                <option value="Other">Lainnya</option>
              </select>

              <p class="help-block">{{ loanFormData.errors.educationType }}</p>
            </div>

            <div
              class="form-group"
              [ngClass]="{
                'has-error': loanFormData.errors.dependants,
                'has-success': loanFormData.form.controls.dependants.valid
              }"
            >
              <label class="help-block">Jumlah Tanggungan</label>
              <p>Masukkan jumlah orang yang ditanggung dengan angka</p>

              <input
                type="tel"
                class="form-control"
                name="dependants"
                formControlName="dependants"
                id="inp_jmlTanggungan"
                (keypress)="numericalInputOnly($event)"
              />

              <p class="help-block">{{ loanFormData.errors.dependants }}</p>
            </div>
          </div>
        </ng-container>

        <!-- <ng-container *ngIf="loanFormData.step == 7">
    			<ng-container *ngIf="!loanFormData.editReviewForm">
    				<div class="loanform__card">

    					<div class="form-group">
    						<label class="help-block">Jumlah Pinjaman</label>

    						<p>{{loanFormData.form.controls.loanAmount.value? (loanFormData.form.controls.loanAmount.value | tnkCurrency: 'rupiah') : 'Tidak ada data'}}</p>
    					</div>

    					<div class="form-group">
    						<label class="help-block">Periode Pinjaman</label>

    						<p>{{loanFormData.form.controls.loanPeriod.value? loanFormData.form.controls.loanPeriod.value + ' Bulan' : 'Tidak ada data'}}</p>
    					</div>

    					<div class="form-group">
    						<label class="help-block">Tujuan Pinjaman</label>

    						<p *ngIf="loanFormData.form.controls.loanPurpose.value == '0'">Tidak ada data</p>

    						<p *ngIf="loanFormData.form.controls.loanPurpose.value == 'Holiday'">Liburan</p>

    						<p *ngIf="loanFormData.form.controls.loanPurpose.value == 'HousingLoan'">KPR</p>

    						<p *ngIf="loanFormData.form.controls.loanPurpose.value == 'CarOrMotorcycle'">Mobil/Motor</p>

    						<p *ngIf="loanFormData.form.controls.loanPurpose.value == 'CreditCard'">Kartu Kredit</p>

    						<p *ngIf="loanFormData.form.controls.loanPurpose.value == 'Renovation'">Renovasi</p>

    						<p *ngIf="loanFormData.form.controls.loanPurpose.value == 'ElectronicUnsecuredLoan'">KTA Elektronik</p>

    						<p *ngIf="loanFormData.form.controls.loanPurpose.value == 'Education'">Sekolah</p>

    						<p *ngIf="loanFormData.form.controls.loanPurpose.value == 'VentureCapital'">Modal Usaha</p>

    						<p *ngIf="loanFormData.form.controls.loanPurpose.value == 'Investment'">Investasi</p>

    						<p *ngIf="loanFormData.form.controls.loanPurpose.value == 'Other'">Lainnya</p>
    					</div>

    					<div class="form-group">
    						<label class="help-block">Nomor KTP (NIK)</label>

    						<p>{{loanFormData.form.controls.pin.value}}</p>
    					</div>

    					<div class="form-group">
    						<label class="help-block">Nama Bank</label>

    						<p>{{loanFormData.selectedBankName}}</p>
    					</div>

    					<div class="form-group">
    						<label class="help-block">Nomor Rekening</label>

    						<p>{{loanFormData.form.controls.bankAccount.value}}</p>
    					</div>


    					<div class="form-group">
    						<label class="help-block">Darimana Anda mengetahui Tunaiku</label>

    						<p *ngIf="loanFormData.form.controls.mediasource.value == '0'">Tidak ada data</p>

    						<p *ngIf="loanFormData.form.controls.mediasource.value == 'Friend'">Teman</p>

    						<p *ngIf="loanFormData.form.controls.mediasource.value == 'Internet'">Internet</p>

    						<p *ngIf="loanFormData.form.controls.mediasource.value == 'Radio'">Radio</p>

    						<p *ngIf="loanFormData.form.controls.mediasource.value == 'Brochure'">Selebaran/Brosur</p>

    						<p *ngIf="loanFormData.form.controls.mediasource.value == 'Television'">Televisi</p>

    						<p *ngIf="loanFormData.form.controls.mediasource.value == 'Other'">Lainnya</p>
    					</div>

    					<div class="form-group align--center">
    						<button id="inp_ubahData" class="tnk__button button--hole button--blue button--margin-sm" (click)="service.confirmEditReview()">Ubah Data</button>
    					</div>
    				</div>

    				<span class="clearfix"></span>

    				<div class="col-sm-12">
    					<div class="checkbox__wrapper">
    						<div class="checkbox">
    							<label class="help-block"><input type="checkbox" (change)="service.agreeToFormPrivacy($event)" name="agreedForm" formControlName="agreedForm" id="inp_agreement" /> Saya menyetujui syarat dan ketentuan umum serta kebijakan privasi yang ditetapkan oleh PT Bank Amar Indonesia</label>
    						</div>
    					</div>
    				</div>

    			</ng-container>

    			<ng-container *ngIf="loanFormData.editReviewForm">
    				<div class="col-sm-12" style="padding-left: 5.5px; padding-right: 5.5px">
    					<tnk-loan-slider [stateURI]="false" [sliderState]="1" [sliderOnly]="true" (sliderOnChange)="service.handleLoanSlider('amount_period', $event)" (purposeOnChange)="service.handleLoanSlider('purpose', $event)"></tnk-loan-slider>
    				</div>

    				<div class="loanform__card has--top-widget">				

    					<div class="form-group" [ngClass]="{'has-error': loanFormData.errors.pin || loanFormData.doubleKTP, 'has-success': loanFormData.form.controls.pin.valid && !loanFormData.doubleKTP}">

    						<label class="help-block">Nomor KTP (NIK)</label>
    						<input type="text" class="form-control" name="pin" formControlName="pin" id="inp_noKTP" (blur)="service.checkUserKTP(loanFormData.form.controls.pin.value)" />

    						<p class="help-block">{{loanFormData.errors.pin}}</p>
    					</div>

    					<div class="form-group" [ngClass]="{'has-error': loanFormData.errors.bankName, 'has-success': loanFormData.form.controls.bankName.valid}">
    						<label class="help-block">Nama Bank</label>

    						<select class="form-control" name="bankName" formControlName="bankName" id="inp_namaBank">
    							<option value="0">Pilih salah satu</option>
    							<option *ngFor="let bank of loanFormData.banks" [value]="bank.code">{{bank.name}}</option>
    						</select>

    						<p class="help-block">{{loanFormData.errors.bankName}}</p>
    					</div>

    					<div class="form-group" [ngClass]="{'has-error': loanFormData.errors.bankAccount, 'has-success': loanFormData.form.controls.bankAccount.valid}">
    						<label class="help-block">Nomor Rekening</label>

    						<input type="text" class="form-control" name="bankAccount" formControlName="bankAccount" placeholder="Uang pinjaman akan dikirim ke nomor ini" id="inp_noRekening" />

    						<p class="help-block">{{loanFormData.errors.bankAccount}}</p>
    					</div>

    					<div class="form-group" [ngClass]="{'has-error': loanFormData.errors.mobilePhoneNumber, 'has-success': loanFormData.form.controls.mobilePhoneNumber.valid}">
    						<label class="help-block">Nomor Handphone</label>

    						<div class="input-group">
    							<span class="input-group-addon">+62</span>
    							<input type="text" class="form-control" name="mobilePhoneNumber" formControlName="mobilePhoneNumber" id="inp_noHandphone" />
    						</div>

    						<p class="help-block">{{loanFormData.errors.mobilePhoneNumber}}</p>
    					</div>

    					<div class="form-group" [ngClass]="{'has-error': loanFormData.errors.emailAddress, 'has-success': loanFormData.form.controls.emailAddress.valid}">
    						<label class="help-block">Email</label>

    						<input type="text" class="form-control" name="emailAddress" formControlName="emailAddress" id="inp_email" />

    						<p class="help-block">{{loanFormData.errors.emailAddress}}</p>
    					</div>

    					<div class="form-group" [ngClass]="{'has-error': loanFormData.errors.mediasource, 'has-success': loanFormData.form.controls.mediasource.valid}">
    						<label class="help-block">Darimana Anda mengetahui Tunaiku?</label>

    						<select class="form-control" name="mediasource" formControlName="mediasource">
                                <option value="0">Pilih salah satu</option>
                                <option value="Internet">Internet</option>
                                <option value="Friend">Teman</option>
                                <option value="Radio">Radio</option>
                                <option value="Brochure">Selebaran/Brosur</option>
                                <option value="Television">Televisi</option>
                                <option value="Other">Lainnya</option>
                            </select>

                            <p class="help-block">{{loanFormData.errors.mediasource}}</p>
    					</div>

    					<div class="checkbox__wrapper">
    						<div class="checkbox">
    							<label class="help-block"><input type="checkbox" (change)="service.agreeToFormPrivacy($event)" name="agreedForm" formControlName="agreedForm" id="inp_agreement" /> Saya menyetujui syarat dan ketentuan umum serta kebijakan privasi yang ditetapkan oleh PT Bank Amar Indonesia</label>
    						</div>
    					</div>

    					<div class="form-group align--center">						
    						<button class="tnk__button button--hole button--blue button--margin-sm" (click)="service.confirmEditReview()" [disabled]="service.stepValidator(9)">Simpan Data</button>
    					</div>
    				</div>
    			</ng-container>
    		</ng-container> -->
      </form>

      <div
        id="auth-loan-form-footer"
        class="loanform__card"
        [hidden]="loanFormData.editReviewForm || !loanFormData.showActionButton"
      >
        <div class="form-group no--margin">
          <p class="pull-right">*) Lengkapi data agar bisa melanjutkan formulir</p>
          <span class="clearfix"></span>

          <button
            id="inp_formSebelumnya"
            type="button"
            class="tnk__button button--hole button--green button--float-left button--lg no--margin"
            (click)="service.stepHandler(loanFormData.step, 'previous')"
          >
            < Kembali
          </button>
          <button
            id="inp_formSelanjutnya"
            type="button"
            class="tnk__button button--green button--float-right button--lg no--margin"
            [disabled]="loanFormData.disabledNextButton"
            (click)="service.stepHandler(loanFormData.step, 'next')"
            data-toggle="tooltip"
            title="Lengkapi data agar bisa melanjutkan formulir"
          >
            {{ loanFormData.step == 5 ? 'Kirim Formulir' : 'Selanjutnya
    					>' }}
          </button>
        </div>
      </div>
    </div>

    <section class="tnk__modal" *ngIf="loanFormData.submitBusy">
      <div class="modal__inner modal--size-small">
        <div class="modal__content content--align-center">
          <h4 class="head__icon">
            <span class="icon glyphicon glyphicon-refresh icon--green"></span>
          </h4>
          <h4 class="clr--green">Pinjaman sedang diajukan</h4>

          <p>
            Pengajuan Anda sedang diproses. Pastikan jaringan Anda aman dan mohon
            jangan menutup tab atau jendela browser.
          </p>
        </div>
      </div>
    </section>


    <tnk-modal [isOpen]="isFraudAttemptAlert">
      <tnk-modal-body class="tnk-align--center">
        <h6>Maaf Ada Kesalahan Pada Data</h6>
        <p>
          Sistem kami menemukan adanya kesalahan pada data anda, silahkan hubungi
          tim kami untuk memastikan data-data anda sudah sesuai.
        </p>
      </tnk-modal-body>
      <tnk-modal-footer>
        <button
          class="tnk-button tnk-button--secondary tnk-button--full-width tnk-button--pill"
          (click)="closeFraudAttemptAlert()"
        >
          Hubungi Kami Melalui Chat
        </button>
      </tnk-modal-footer>
    </tnk-modal>
  `,
  styles: [`
    .pd-left-right-20 {
      padding-left: 20px;
      padding-right: 20px;
    }
    .separator {
      position: relative;
      width: 100%;
      height: 1px;
      display: block;
      overflow: hidden;
      background-color: #ececec;
      margin: 5px auto;
    }
    .separator:after {
      content: ' ';
    }
    .table.table--borderless td,
    .table.table--borderless th {
      border: none;
    }
    .table.table--borderless td {
      font-size: 14px;
    }
    .separator {
      position: relative;
      display: block;
      height: 1px;
      width: 100%;
      background-color: #ccc;
      margin-bottom: 10px;
    }
    .no--margin {
      margin: 0 !important;
    }
    a.link {
      -webkit-transition: all 0.2s ease-in-out;
      transition: all 0.2s ease-in-out;
      font-weight: bold;
    }
    a.link.link--clr-blue:link {
      color: #004c7b;
    }
    .form-group.align--center {
      text-align: center;
    }
    .form-wrapper .form-group {
      margin-bottom: 20px;
      display: block;
      overflow: hidden;
    }
    .form-wrapper .form-group.align--center {
      text-align: center;
    }
    .form-wrapper .form-group .help-block {
      font-size: 13px;
    }
    .form-wrapper .form-group .help-block.label--control {
      color: #444;
    }
    .form-wrapper .form-group .col-sm-* p {
      margin-bottom: 15px;
    }
    a.tnk__button {
      text-decoration: none;
    }
    .tnk__button {
      position: relative;
      display: inline-block;
      min-width: 70px;
      padding: 10px;
      -webkit-appearance: none;
         -moz-appearance: none;
              appearance: none;
      outline: 0;
      cursor: pointer;
      border: 1px solid transparent;
      font-family: 'HelveticaBold', sans-serif;
      font-weight: bold;
      margin: 0 auto;
      border-radius: 35px;
      -webkit-box-shadow: 0 2px 4.8px 0.3px rgba(0,0,0,0.25);
              box-shadow: 0 2px 4.8px 0.3px rgba(0,0,0,0.25);
      text-transform: uppercase;
      margin-top: 15px;
    }
    .tnk__button[disabled] {
      cursor: not-allowed;
    }
    .tnk__button.button--sm {
      font-size: 12px;
    }
    .tnk__button.button--lg {
      font-size: 14px;
      font-weight: bold;
      padding: 15px 30px;
    }
    .tnk__button.button--block {
      min-width: 100%;
      width: 100%;
      padding: 10px 0;
    }
    .tnk__button.button--float-right {
      float: right;
      margin-right: 10px;
    }
    .tnk__button.button--float-left {
      float: left;
      margin-left: 10px;
    }
    .tnk__button.button--min {
      width: 110px;
      padding: 10px 5px;
      margin-bottom: 5px;
    }
    .tnk__button.button--green {
      font-size: 12px;
      color: #fff;
      background-color: #81be41;
    }
    .tnk__button.button--green.button--lg {
      font-size: 14px;
    }
    .tnk__button.button--green:hover {
      background-color: #72b63e;
    }
    .tnk__button.button--green:active {
      color: #f2f2f2;
      bakground-color: #6ab631;
      -webkit-box-shadow: inset 2px 6px 3px rgba(0,0,0,0.075);
              box-shadow: inset 2px 6px 3px rgba(0,0,0,0.075);
    }
    .tnk__button.button--green[disabled] {
      background-color: #b7b7b7;
      color: #fff;
    }
    .tnk__button.button--green.button--sm {
      -webkit-box-shadow: none;
              box-shadow: none;
      padding: 8.5px 10px;
    }
    .tnk__button.button--blue {
      background-color: #1a72a4;
      color: #fff;
      font-size: 12px;
    }
    .tnk__button.button--blue.button--lg {
      font-size: 14px;
    }
    .tnk__button.button--blue:hover {
      background-color: #1e6a94;
      color: #fff;
    }
    .tnk__button.button--blue:active {
      color: #f2f2f2;
      background-color: #004c7b;
      -webkit-box-shadow: inset 2px 6px 3px rgba(0,0,0,0.075);
              box-shadow: inset 2px 6px 3px rgba(0,0,0,0.075);
    }
    .tnk__button.button--blue[disabled] {
      background-color: #b7b7b7;
      color: #fff;
    }
    .tnk__button.button--blue.button--min {
      font-size: 10px;
    }
    .tnk__button.button--red {
      background-color: #721c24;
      color: #fff;
    }
    .tnk__button.button--hole {
      border-radius: 16.5px;
      padding: 7px 10px;
    }
    .tnk__button.button--hole.button--red {
      background-color: #fff;
      border: 2px solid #721c24;
      color: #721c24;
    }
    .tnk__button.button--hole.button--red:hover,
    .tnk__button.button--hole.button--red :active {
      background-color: #721c24;
      color: #fff;
    }
    .tnk__button.button--hole.button--green {
      background-color: transparent;
      border: 2px solid #81be41;
      color: #81be41;
    }
    .tnk__button.button--hole.button--green.button--lg {
      font-size: 14px;
      font-weight: bold;
      padding: 15px 30px;
      border-radius: 15.5px;
    }
    .tnk__button.button--hole.button--green.button--active {
      background-color: #81be41;
      color: #fff;
    }
    .tnk__button.button--hole.button--green.button--active:hover,
    .tnk__button.button--hole.button--green.button--active :active {
      background-color: #6ab631;
    }
    .tnk__button.button--hole.button--green:hover {
      background-color: #81be41;
      color: #fff;
    }
    .tnk__button.button--hole.button--blue {
      background-color: transparent;
      border: 2px solid #1a72a4;
      color: #1a72a4;
    }
    .tnk__button.button--hole.button--blue.button--lg {
      font-size: 14px;
      font-weight: bold;
      padding: 15px 30px;
      border-radius: 15.5px;
    }
    .tnk__button.button--hole.button--blue.button--active {
      background-color: #1a72a4;
      color: #fff;
    }
    .tnk__button.button--hole.button--blue.button--active:hover,
    .tnk__button.button--hole.button--blue.button--active :active {
      background-color: #1a72a4;
    }
    .tnk__button.button--hole.button--blue:hover,
    .tnk__button.button--hole.button--blue :active {
      background-color: #1a72a4;
      color: #fff;
    }
    .tnk__button.button--hole.button--blue[disabled] {
      border: 2px solid transparent;
      background-color: #1a72a4;
      color: #fff;
    }
    .tnk__button.button--margin-sm {
      margin-top: 5px;
      margin-right: 15px;
      min-width: 200px;
    }
    .tnk__button.button--margin-md {
      margin-top: 10px;
      margin-right: 15px;
      min-width: 200px;
    }
    .tnk__button .icon {
      margin-right: 10px;
    }
    .tnk__modal {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 5000;
      width: 100%;
      height: 100vh;
      overflow: hidden;
      background-color: rgba(0,0,0,0.75);
    }
    .tnk__modal .modal__inner {
      position: relative;
      border-radius: 8px;
      background-color: #fff;
      -webkit-box-shadow: 0 0 5px 3px rgba(0,0,0,0.25);
              box-shadow: 0 0 5px 3px rgba(0,0,0,0.25);
      width: 80%;
      min-height: 240px;
      margin: 7.5% auto 0;
      display: block;
    }
    .tnk__modal .modal__inner.modal--size-small {
      width: 30%;
      border-radius: 8px;
      min-height: 120px;
      margin: 0 auto;
    }
    .tnk__modal .modal__inner.modal--size-small .modal__content {
      margin-top: 25vh;
      padding: 30px;
    }
    .tnk__modal .modal__inner .modal__content {
      position: relative;
      display: block;
      overflow: hidden;
    }
    .tnk__modal .modal__inner .modal__content.content--align-center {
      text-align: center;
    }
    .tnk__modal .modal__inner .modal__content h4 {
      font-size: 22px;
      color: #81be41;
    }
    .tnk__modal .modal__inner .modal__content .head__icon {
      font-size: 48px;
    }
    .tnk__modal .modal__inner .modal__content p {
      color: #8a8989;
      margin-top: 28px;
    }
    .checkbox__wrapper {
      position: relative;
      display: block;
      overflow: hidden;
      background-color: #cfe6f0;
      padding: 20px 30px;
      border-radius: 5px;
      margin: 0 0 10px;
    }
    .checkbox__wrapper.has-error {
      background-color: #f2dede;
    }
    .checkbox__wrapper.has-error p {
      color: #721c24;
    }
    .checkbox__wrapper label {
      color: #191919;
    }
    .checkbox__wrapper label input[type=checkbox] {
      width: 16px;
      height: 16px;
      margin-left: -25px;
      margin-top: 3px;
    }
    .birth__province {
      padding-left: 0 !important;
    }
    .birth__city {
      padding-right: 0 !important;
    }
    @media screen and (min-width: 240px) and (max-width: 800px) {
      .birth__province {
        padding-left: 0 !important;
        padding-right: 0 !important;
      }
      .birth__city {
        padding-left: 0 !important;
        padding-right: 0 !important;
      }
      .tnk__button.button--margin-sm {
        min-width: 42.5%;
      }
      .tnk__button.button--green.button--lg {
        padding: 10px;
      }
      .tnk__button.button--hole.button--green.button--lg {
        padding: 10px;
      }
      .tnk__button.button--float-left {
        margin-left: 0;
      }
      .tnk__modal .modal__inner.modal--size-small {
        width: 100%;
        border-radius: 0;
        min-height: 100vh;
      }
      .tnk__modal .modal__inner.modal--size-small .modal__content {
        margin-top: 0;
        padding: 0;
        padding-top: 25vh;
      }
    }
    @media screen and (max-width: 1024px) {
      .tnk__button.button--hole.button--green:active {
        background-color: #81be41;
        color: #fff;
      }
    }
    @media screen and (min-width: 1024px) {
      .tnk__modal .modal__inner.modal--size-small .modal__content {
        padding-top: 25;
      }
      .checkbox__wrapper {
        margin: 0 0 10px;
      }
    }
    #auth-loan-form-footer {
      position: -webkit-sticky;
      position: sticky;
      bottom: 0;
      z-index: 1000;
    }
    .loanform__wrapper {
      position: relative;
      display: block;
      width: 100%;
      overflow: visible;
      padding-bottom: 15px;
    }
    .loanform__wrapper .loanform__card {
      width: 98%;
      background-color: #fff;
      margin: 5px auto 20px;
      border-radius: 5px;
      -webkit-box-shadow: 0 0 3px 1px rgba(28,28,28,0.15);
              box-shadow: 0 0 3px 1px rgba(28,28,28,0.15);
      padding: 20px;
      overflow: hidden;
    }
    .loanform__wrapper .loanform__card.has--top-widget {
      border-radius: 0 0 5px 5px;
      margin: 0 auto 20px;
      padding-top: 20px;
    }
    .loanform__wrapper .loanform__card.has--subtitle h4 {
      margin-bottom: 5px;
    }
    .loanform__wrapper .loanform__card.has--subtitle p.subtitle {
      margin-bottom: 30px;
    }
    .loanform__wrapper .loanform__card h4 {
      font-family: 'HelveticaBold', sans-serif;
      font-weight: bold;
      font-size: 24px;
      color: #535353;
      margin-bottom: 20px;
    }
    .loanform__wrapper .loanform__card h4.border__title {
      padding-bottom: 15px;
      border-bottom: 1px solid #ccc;
    }
    .loanform__wrapper .loanform__card p {
      font-size: 13px;
    }
    .loanform__wrapper .loanform__card p.text__length {
      text-align: right;
      margin-top: 10px;
    }
    .loanform__wrapper .loanform__card input[type=checkbox],
    .loanform__wrapper .loanform__card input[type=radio] {
      margin-top: 2px;
    }
    .loanform__wrapper .alert {
      margin-top: 20px;
      display: block;
      overflow: hidden;
    }
    .loanform__wrapper .alert.alert-danger h4 {
      color: #721c24;
    }
    .loanform__wrapper .alert.alert-danger p {
      color: #721c24;
    }
    .loanform__wrapper .alert.alert-success p {
      color: #155724;
    }
    .form-group.has-error label.help-block {
      color: #a94442;
    }
    .form-group.has-success label.help-block {
      color: #3c763d;
    }
    .form-group label {
      margin-bottom: 0;
      color: #444;
      font-weight: normal;
    }
    .form-group label.help-block {
      margin-top: 10px;
    }
    .form-group input,
    .form-group textarea,
    .form-group select {
      margin-top: 5px;
    }
    .form-group .input-group input,
    .form-group .input-group textarea,
    .form-group .input-group select {
      margin-top: 0;
    }
    .form-group p {
      font-style: italic;
      color: #888;
      margin-bottom: 5px;
    }
    .form-group p.bold {
      font-weight: bold;
    }
    .form-group p.help-block {
      font-style: normal;
    }
  `],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: TNKAuthLoanFormService, },
{type: Router, },
{type: PlatformService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'accessToken': [{ type: Input, args: ['accessToken', ] },],
'cookieService': [{ type: Input, args: ['cookieService', ] },],
'successCallbackURI': [{ type: Input, args: ['successCallbackURI', ] },],
'errorServerCallbackURI': [{ type: Input, args: ['errorServerCallbackURI', ] },],
'stepURI': [{ type: Input, args: ['stepURI', ] },],
'activeStep': [{ type: Input, args: ['activeStep', ] },],
'actionButton': [{ type: Input, args: ['showActionButton', ] },],
'busyServerCallbackURI': [{ type: Input, args: ['busyServerCallbackURI', ] },],
'isDebug': [{ type: Input, args: ['debug', ] },],
};
}

function TNKAuthLoanFormComponent_tsickle_Closure_declarations() {
/** @type {?} */
TNKAuthLoanFormComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TNKAuthLoanFormComponent.ctorParameters;
/** @type {?} */
TNKAuthLoanFormComponent.propDecorators;
/** @type {?} */
TNKAuthLoanFormComponent.prototype.loanForm;
/** @type {?} */
TNKAuthLoanFormComponent.prototype.formData;
/** @type {?} */
TNKAuthLoanFormComponent.prototype.loanFormData;
/** @type {?} */
TNKAuthLoanFormComponent.prototype.hideButton;
/** @type {?} */
TNKAuthLoanFormComponent.prototype.additionalParameter;
/** @type {?} */
TNKAuthLoanFormComponent.prototype.os;
/** @type {?} */
TNKAuthLoanFormComponent.prototype.device;
/** @type {?} */
TNKAuthLoanFormComponent.prototype.browserType;
/** @type {?} */
TNKAuthLoanFormComponent.prototype.platform;
/** @type {?} */
TNKAuthLoanFormComponent.prototype.loanInfo;
/** @type {?} */
TNKAuthLoanFormComponent.prototype.isCookie;
/** @type {?} */
TNKAuthLoanFormComponent.prototype.subscription1;
/** @type {?} */
TNKAuthLoanFormComponent.prototype.subscription2;
/** @type {?} */
TNKAuthLoanFormComponent.prototype.LOAN_PURPOSE_ENTREPRENEUR;
/** @type {?} */
TNKAuthLoanFormComponent.prototype.BUSINESS_TYPE_ENTREPRENEUR;
/** @type {?} */
TNKAuthLoanFormComponent.prototype.BUSINESS_AGE_ENTREPRENEUR;
/** @type {?} */
TNKAuthLoanFormComponent.prototype.BUSINESS_PROMOTION_ENTREPRENEUR;
/** @type {?} */
TNKAuthLoanFormComponent.prototype.ONLINE_CHANNEL_ENTREPRENEUR;
/** @type {?} */
TNKAuthLoanFormComponent.prototype.BUSINESS_PLACE_ENTREPRENEUR;
/** @type {?} */
TNKAuthLoanFormComponent.prototype.NUMBER_OF_EMPLOYEES_ENTREPRENEUR;
/** @type {?} */
TNKAuthLoanFormComponent.prototype.HELPED_BY_FAMILY_MEMBERS;
/** @type {?} */
TNKAuthLoanFormComponent.prototype.numericalInputOnly;
/** @type {?} */
TNKAuthLoanFormComponent.prototype.numberDelimiter;
/** @type {?} */
TNKAuthLoanFormComponent.prototype.isFraudAttemptAlert;
/** @type {?} */
TNKAuthLoanFormComponent.prototype.accessToken;
/** @type {?} */
TNKAuthLoanFormComponent.prototype.cookieService;
/** @type {?} */
TNKAuthLoanFormComponent.prototype.successCallbackURI;
/** @type {?} */
TNKAuthLoanFormComponent.prototype.errorServerCallbackURI;
/** @type {?} */
TNKAuthLoanFormComponent.prototype.stepURI;
/** @type {?} */
TNKAuthLoanFormComponent.prototype.activeStep;
/** @type {?} */
TNKAuthLoanFormComponent.prototype.actionButton;
/** @type {?} */
TNKAuthLoanFormComponent.prototype.busyServerCallbackURI;
/** @type {?} */
TNKAuthLoanFormComponent.prototype.isDebug;
/** @type {?} */
TNKAuthLoanFormComponent.prototype.showForm;
/** @type {?} */
TNKAuthLoanFormComponent.prototype.service;
/** @type {?} */
TNKAuthLoanFormComponent.prototype.router;
/** @type {?} */
TNKAuthLoanFormComponent.prototype.platformService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
